import _parseInt from '@babel/runtime-corejs3/core-js-stable/parse-int';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import { customProperties } from '@commercetools-uikit/design-system';
import _extends from '@babel/runtime-corejs3/helpers/esm/extends';
import _styled from '@emotion/styled/base';
import _findInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find';
import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';
import _reduceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reduce';
import React, { useCallback } from 'react';
import reactIs from 'react-is';
import { jsx, ThemeProvider, useTheme, css, Global } from '@emotion/react';
import _slicedToArray from '@babel/runtime-corejs3/helpers/esm/slicedToArray';
import _pt from 'prop-types';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import SpacingsInline from '@commercetools-uikit/spacings-inline';
import _WeakMap from '@babel/runtime-corejs3/core-js-stable/weak-map';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$create from '@babel/runtime-corejs3/core-js-stable/object/create';
import _Symbol$replace from '@babel/runtime-corejs3/core-js-stable/symbol/replace';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';
import _Symbol from '@babel/runtime-corejs3/core-js-stable/symbol';
import _getIteratorMethod from '@babel/runtime-corejs3/core-js/get-iterator-method';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _inherits from '@babel/runtime-corejs3/helpers/esm/inherits';
import _setPrototypeOf from '@babel/runtime-corejs3/helpers/esm/setPrototypeOf';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _trimInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/trim';
import _Array$from from '@babel/runtime-corejs3/core-js-stable/array/from';
import _matchAllInstanceProperty from '@babel/runtime-corejs3/core-js/instance/match-all';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import _setTimeout from '@babel/runtime-corejs3/core-js-stable/set-timeout';
import _someInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/some';
import ReactDOM from 'react-dom';
import Tooltip from '@commercetools-uikit/tooltip';
import { ClipboardIcon, InformationIcon, ErrorIcon, WarningIcon } from '@commercetools-uikit/icons';
import Highlight, { defaultProps } from 'prism-react-renderer';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/esm/toConsumableArray';
import nightOwl from 'prism-react-renderer/themes/nightOwl';
import nightOwlLight from 'prism-react-renderer/themes/nightOwlLight';
import _asyncToGenerator from '@babel/runtime-corejs3/helpers/esm/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime-corejs3/regenerator';
import _Promise from '@babel/runtime-corejs3/core-js-stable/promise';
import _sortInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/sort';
import _flatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/flat';
import useSWR from 'swr';
import LoadingSpinner from '@commercetools-uikit/loading-spinner';
import invariant from 'tiny-invariant';
import unified from 'unified';
import filter from 'unist-util-filter';
import rehypeReact from 'rehype-react';
import remarkParse from 'remark-parse';
import remarkFrontmatter from 'remark-frontmatter';
import remarkRehype from 'remark-rehype';
import { useIntl } from 'react-intl';

var rootFontSizeNumber = 16; // the "width availability contract" with content is that content
// always has between "pageWidthSmall" and "pageWidth" available and
// must float / stretch into the available width

var pageWidth = '770px';
var pageWidthSmall = '592px';
var asideColumnWidth = pageWidthSmall;
var navbarWidth = '224px';
var navbarWidthSmall = '200px';
var pxToRem = function pxToRem(px) {
  var _context;

  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'rem';
  var pxNumber = px.replace(/([0-9]+)px$/, '$1');
  var remNumber = _parseInt(pxNumber, 10) / rootFontSizeNumber;
  return _concatInstanceProperty(_context = "".concat(remNumber)).call(_context, suffix);
};
var colors = {
  light: {
    // Surfaces are used for backgrounds
    surfacePrimary: customProperties.colorSurface,
    surfaceSecondary1: customProperties.colorNeutral95,
    surfaceSecondary2: customProperties.colorNeutral90,
    surfaceSecondary3: customProperties.colorNeutral60,
    surfaceInlineCode: customProperties.colorNeutral95,
    surfaceCode: customProperties.colorAccent,
    surfaceCodeCopy: customProperties.colorAccent30,
    surfaceCodeHighlight: customProperties.colorAccent40,
    surfaceInfo: customProperties.colorInfo95,
    surfaceBeta: customProperties.colorInfo85,
    surfaceQuote: customProperties.colorAccent98,
    surfaceWarning: customProperties.colorWarning95,
    surfaceError: customProperties.colorError95,
    surfaceSearchHighlight: customProperties.colorAccent95,
    surfaceForSearchInputWhenDisabled: customProperties.colorNeutral90,
    surfaceForReleaseNoteTypeFix: '#e4c5ff',
    // Different tones of text
    textPrimary: customProperties.colorSolid,
    textSecondary: '#666666',
    textFaded: customProperties.colorNeutral60,
    textCode: customProperties.colorError,
    textInfo: customProperties.colorInfo,
    textError: customProperties.colorError,
    textWarning: customProperties.colorWarning,
    textInverted: customProperties.colorSurface,
    textSearchHeading: customProperties.colorPrimary25,
    // Different tones of border colors
    borderPrimary: customProperties.colorNeutral90,
    borderSecondary: customProperties.colorNeutral,
    borderInput: customProperties.colorNeutral60,
    borderHighlight: customProperties.colorPrimary,
    borderInfo: customProperties.colorInfo,
    borderForReleaseNoteTypeFix: '#b866ff',
    // Links
    link: customProperties.colorPrimary25,
    linkHover: customProperties.colorPrimary,
    linkNavigation: customProperties.colorInfo,
    // Headlines
    headlinePrimary: '#003037',
    // Code blocks
    // We support 2 theme versions: a primary one and a secondary one.
    // This is not to be confused with a (potential) website theme, hence
    // the 2 versions being grouped together.
    // The code block theme is controlled by a prop, which will use the
    // emotion theming provider to inject the correct version of a theme.
    //
    //   <ThemeProvider
    //     theme={{
    //       codeBlockColors: colors.light.codeBlocks[props.secondaryTheme ? 'secondary' : 'primary'],
    //     }}
    //   >
    //
    // Do not use these properties directly, but always through an emotion theme provider.
    codeBlocks: {
      primary: {
        border: customProperties.colorAccent40,
        surface: customProperties.colorAccent,
        surfaceHeader: customProperties.colorSolid,
        surfaceLanguageDropdown: customProperties.colorSurface,
        surfaceLanguageDropdownHover: customProperties.colorNeutral90,
        textHeader: customProperties.colorNeutral60,
        surfaceCopyIcon: customProperties.colorSurface,
        surfaceCopyIconHover: customProperties.colorAccent40,
        surfaceCopyTooltip: customProperties.colorAccent40,
        textCopyTooltip: customProperties.colorSurface,
        surfaceLineHighlight: customProperties.colorAccent40,
        surfacePrompt: customProperties.colorNeutral60
      },
      secondary: {
        border: customProperties.colorNeutral90,
        surface: customProperties.colorSurface,
        surfaceHeader: customProperties.colorNeutral,
        surfaceLanguageDropdown: customProperties.colorSolid,
        surfaceLanguageDropdownHover: customProperties.colorNeutral60,
        textHeader: customProperties.colorSolid,
        surfaceCopyIcon: customProperties.colorSolid,
        surfaceCopyIconHover: customProperties.colorAccent40,
        surfaceCopyTooltip: customProperties.colorAccent40,
        textCopyTooltip: customProperties.colorSurface,
        surfaceLineHighlight: customProperties.colorNeutral90,
        surfacePrompt: customProperties.colorNeutral60
      }
    }
  }
};
var tokens = {
  borderRadiusForBetaFlag: customProperties.borderRadius4,
  borderRadiusForSearchDialog: customProperties.borderRadius6,
  borderRadiusForSearchInput: customProperties.borderRadius6,
  borderRadiusForCodeBlock: customProperties.borderRadius6,
  borderRadiusForTooltip: customProperties.borderRadius4,
  borderRadiusForContentNotification: customProperties.borderRadius6,
  borderRadiusForImageFrame: customProperties.borderRadius6,
  borderRadiusForBlockquote: customProperties.borderRadius6,
  borderRadiusForCard: customProperties.borderRadius6,
  borderRadiusForChildSectionNav: customProperties.borderRadius6,
  borderRadiusForRssFeedTable: customProperties.borderRadius6,
  shadowForBetaFlag: customProperties.shadow7,
  shadowForSearchDialog: customProperties.shadow2,
  shadowForPageContent: customProperties.shadow11,
  shadowForClickableCard: "1px 1px 4px 0 rgba(0, 0, 0, 0.24),\n  -1px 1px 3px 0 rgba(0, 0, 0, 0.12)",
  shadowForClickableCardOnHover: "0 14px 28px 0 rgba(0, 0, 0, 0.25),\n  0 10px 10px 0 rgba(0, 0, 0, 0.23)",
  shadowForRssFeedTable: customProperties.shadow7
};
var dimensions = {
  heights: {
    header: '48px',
    inputSearchPrimary: '32px',
    inputSearchSecondary: '26px',
    childSectionNavLink: '28px',
    pageSearchboxSpace: '58px',
    globalNotificationContent: '36px'
  },
  widths: {
    pageContent: pageWidth,
    pageContentSmall: pageWidthSmall,
    pageContentWide: "calc(".concat(pageWidth, " + ").concat(asideColumnWidth, " + 32px)"),
    pageContentWithMargins: "calc(".concat(pageWidth, " + 32px * 2)"),
    pageContentSmallWithMargins: "calc(".concat(pageWidthSmall, " + 16px * 2)"),
    pageContentWideWithMargins: "calc(".concat(pageWidthSmall, " + ").concat(asideColumnWidth, " + 32px * 3)"),
    pageContentWideWithMarginsMax: "calc(".concat(pageWidth, " + ").concat(asideColumnWidth, " + 32px * 3)"),
    pageContentWithMarginsAndPageNavigation: "calc(".concat(pageWidth, " + 32px * 2 + ").concat(navbarWidth, ")"),
    pageNavigation: navbarWidth,
    pageNavigationSmall: navbarWidthSmall,
    marketingContent: '1168px',
    searchBar: '300px',
    searchBarSmall: '160px',
    selectDropDownArrowWith: '12px',
    sideBySideSecondColumn: asideColumnWidth,
    multiColumnLayoutColumnWidth: '240px',
    // The card sizes are manually optimized to make regular cards two-aside on landing pages
    // and narrow cards three-aside in any landing page size.
    // Plus, you can put 2,3,4,6 cards in a grid without whitespace.
    // In content page columns it's not ideal, but the numbers just don't add up if we want the same card
    // to perfectly fit the landing pages.
    cardNarrowMinWidth: '242px',
    cardRegularMinWidth: '328px',
    // the "inContentColumn" variation prevents only one card being in one row in regular content (except mobile)
    cardRegularMinWidthInContentColumn: '288px'
  },
  viewports: {
    mobile: "max-width: calc(768px - 0.02px)",
    tablet: "min-width: calc(768px - 0.01px)",
    largeTablet: "min-width: calc(848px - 0.01px)",
    laptop: "min-width: calc(1024px - 0.01px)",
    desktop: "min-width: calc(1280px - 0.01px)",
    largeDesktop: "min-width: calc(1706px - 0.01px)"
  },
  spacings: {
    xs: pxToRem('4px'),
    s: pxToRem('8px'),
    m: pxToRem('16px'),
    l: pxToRem('24px'),
    xl: pxToRem('32px'),
    xxl: pxToRem('40px'),
    big: pxToRem('48px'),
    large: pxToRem('56px'),
    wide: pxToRem('64px'),
    enormous: pxToRem('72px'),
    huge: pxToRem('80px')
  },
  stacks: {
    base: 1,
    sidebar: 2,
    overlay: 20,
    aboveOverlay: 21
  }
};
var typography = {
  fontFamilies: {
    primary: "'Roboto', sans-serif",
    code: "'Roboto Mono', monospace"
  },
  rootFontSize: "".concat(rootFontSizeNumber, "px"),
  fontSizes: {
    h1: pxToRem('48px'),
    h2: pxToRem('26px'),
    h3: pxToRem('24px'),
    h4: pxToRem('20px'),
    h5: pxToRem('16px'),
    h6: pxToRem('16px'),
    body: pxToRem('16px'),
    small: pxToRem('14px'),
    // The sizes below are only used in specific case. Do not use them regularly.
    // If necessary, ask the Design team.
    extraSmall: pxToRem('12px'),
    ultraSmall: pxToRem('10px')
  },
  relativeFontSizes: {
    ultraSmall: pxToRem('10px', 'em')
  },
  fontWeights: {
    regular: '400',
    medium: '500',
    bold: '700'
  },
  lineHeights: {
    small: pxToRem('16px'),
    body: pxToRem('23px'),
    releaseNoteHeader: pxToRem('28px'),
    cardNormalTitle: pxToRem('32px'),
    cardSmallTitle: pxToRem('26px')
  }
};
var uikitTheme = {
  fontFamilyDefault: typography.fontFamilies.primary,
  fontFamilyBody: typography.fontFamilies.primary
};

var designSystem = /*#__PURE__*/Object.freeze({
  __proto__: null,
  pxToRem: pxToRem,
  colors: colors,
  tokens: tokens,
  dimensions: dimensions,
  typography: typography,
  uikitTheme: uikitTheme
});

var SvgHttpApiSmall = function SvgHttpApiSmall(props) {
  return jsx("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("g", {
    fill: "#003037",
    fillRule: "nonzero"
  }, jsx("path", {
    d: "M4.296 17.911h1.47l.29.821h.85L5.41 14.704h-.747l-1.488 3.992v.036h.837l.283-.82Zm.736-2.09.463 1.335h-.921l.458-1.335ZM8.717 17.41h.743c.2.001.397-.036.581-.108.177-.067.337-.165.472-.29a1.24 1.24 0 0 0 .317-.426 1.244 1.244 0 0 0 0-1.052 1.257 1.257 0 0 0-.317-.433 1.592 1.592 0 0 0-1.053-.397H7.838v4.028h.879V17.41Zm0-1.918h.743c.08-.001.159.013.232.042a.687.687 0 0 1 .33.313c.033.066.05.137.052.21a.487.487 0 0 1-.052.216.649.649 0 0 1-.562.355h-.743v-1.136ZM11.568 14.704h1v4.028h-1z"
  }), jsx("path", {
    d: "M20.235 14.028a2.797 2.797 0 0 0-2.755 2.387H15.37V9.643h-3.357V7.056h4.87l3.35 3.295L24 6.593l-3.765-3.758-3.326 3.332h-5.711v3.432H6.629V7.557A2.795 2.795 0 0 0 9.013 4.59 2.797 2.797 0 0 0 6.22 2 2.797 2.797 0 0 0 3.43 4.59a2.795 2.795 0 0 0 2.383 2.967v2.086H1V24h14.371v-6.771h2.084a2.792 2.792 0 0 0 3.032 2.36 2.79 2.79 0 0 0 2.52-2.9 2.79 2.79 0 0 0-2.772-2.661Zm0-10.022 2.585 2.587-2.585 2.606-2.605-2.581 2.605-2.612Zm-15.997.802c0-1.093.888-1.98 1.983-1.98 1.096 0 1.983.887 1.983 1.98s-.887 1.979-1.983 1.979a1.987 1.987 0 0 1-1.983-1.98Zm10.349 18.378H1.816V10.458h12.77v12.728Zm5.648-4.385a1.983 1.983 0 0 1-1.832-1.222 1.977 1.977 0 0 1 .43-2.157 1.986 1.986 0 0 1 2.16-.429 1.98 1.98 0 0 1-.758 3.808Z"
  })));
};

var SvgHttpApi = function SvgHttpApi(props) {
  return jsx("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("g", {
    fill: "#003037",
    fillRule: "nonzero"
  }, jsx("path", {
    d: "M13.606 56.35h4.73l.93 2.65H22l-4.808-13h-2.404L10 58.883V59h2.695l.91-2.65Zm2.365-6.744 1.493 4.307h-2.966l1.473-4.307ZM27.827 54.731h2.391a4.99 4.99 0 0 0 1.871-.349 4.636 4.636 0 0 0 1.518-.931c.44-.387.787-.857 1.019-1.378.249-.539.376-1.12.374-1.707a3.935 3.935 0 0 0-.374-1.688 4.056 4.056 0 0 0-1.019-1.397 5.119 5.119 0 0 0-1.518-.932A4.993 4.993 0 0 0 30.22 46H25v13h2.827v-4.269Zm0-6.189h2.391c.257-.004.512.043.749.136.229.113.439.257.623.427.179.17.326.367.437.582.107.212.163.444.166.679 0 .241-.057.48-.166.698a2.606 2.606 0 0 1-.437.582c-.179.17-.39.309-.623.408-.236.097-.49.15-.749.155h-2.39v-3.667ZM37 46h3v13h-3z"
  }), jsx("path", {
    d: "M64.885 43.818a9.009 9.009 0 0 0-8.863 7.702h-6.785V29.667H38.435v-8.349h15.668l10.782 10.633L77 19.822 64.885 7.693l-10.7 10.755H35.81v11.078H21.111v-6.59c4.668-.689 8.014-4.868 7.669-9.579C28.435 8.646 24.517 5 19.799 5s-8.636 3.646-8.981 8.357c-.345 4.711 3 8.89 7.668 9.579v6.731H3V76h46.237V54.148h6.704c.709 4.734 4.997 8.082 9.756 7.619 4.76-.464 8.321-4.579 8.105-9.36-.216-4.783-4.135-8.558-8.917-8.59Zm0-32.344 8.32 8.348-8.32 8.41-8.379-8.329 8.38-8.43ZM13.42 14.06a6.384 6.384 0 0 1 6.38-6.388c3.524 0 6.38 2.86 6.38 6.388a6.384 6.384 0 0 1-6.38 6.388 6.404 6.404 0 0 1-6.38-6.388Zm33.295 59.311H5.624V32.295h41.09v41.077Zm18.171-14.15a6.38 6.38 0 0 1-5.894-3.944 6.394 6.394 0 0 1 1.383-6.961 6.375 6.375 0 0 1 6.953-1.385 6.388 6.388 0 0 1 3.939 5.902 6.384 6.384 0 0 1-6.38 6.388Z"
  })));
};

var SvgCtLogo = function SvgCtLogo(props) {
  return jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.3 39",
    width: 16,
    height: 16
  }, props), jsx("path", {
    d: "M1.4 29.2c-.2.1-.4.4-.4.7 0 .3.2.6.4.7l14.9 7c.2.1.4.1.6.1V22.1c-.2 0-.4 0-.7.1l-14.8 7z",
    fill: "#f27923"
  }), jsx("path", {
    d: "M17 22.1v15.6c.2 0 .5 0 .7-.1l14.9-7c.3-.1.4-.4.4-.7 0-.3-.2-.6-.4-.7l-14.9-6.9c-.3-.1-.5-.2-.7-.2z",
    fill: "#f5a730"
  }), jsx("path", {
    d: "M1 8.8c0 .3.2.6.4.7l14.9 7c.2.1.4.1.6.1.2 0 .4 0 .6-.1.1-.1.1-.1.4-.2 1.5-.7.5-.2 14.6-6.8.3-.1.5-.4.5-.7 0-.3-.2-.6-.4-.7l-15-7c-.4-.2-.9-.2-1.3 0l-14.9 7c-.2.1-.4.4-.4.7z",
    fill: "#20ad92"
  }), jsx("path", {
    d: "M17 17.5v4.6c-.2 0-.4 0-.7.1l-14.9 7c-.2.1-.4.4-.4.7V8.8c0 .3.2.6.4.7l14.9 7c.2.1.4.1.6.1.2 0 .4 0 .6-.1-.4.2-.5.4-.5 1z",
    fill: "#d0d1d1"
  }));
};

var SvgCustomApplicationSmall = function SvgCustomApplicationSmall(props) {
  return jsx("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("g", {
    fill: "#003037",
    fillRule: "nonzero"
  }, jsx("path", {
    d: "M1 15.944h10.397V2H1v13.944Zm.826-13.125h8.745V15.13H1.826V2.82ZM13.603 10.056V24H24V10.056H13.603Zm9.57 13.125H14.43V10.87h8.745V23.18ZM1 24h10.397v-6.197H1V24Zm.826-5.372h8.745v4.547H1.826v-4.547ZM18.697 7.887h.839V5.67h2.259v-.826h-2.26V2.62h-.838v2.224h-2.259v.826h2.259z"
  })));
};

var SvgCustomApplication = function SvgCustomApplication(props) {
  return jsx("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("g", {
    fill: "#003037",
    fillRule: "nonzero"
  }, jsx("path", {
    d: "M3 50h33V5H3v45ZM5.622 7.642h27.756v39.736H5.622V7.642ZM43 31v45h33V31H43Zm30.378 42.358H45.622V33.622h27.756v39.736ZM3 76h33V56H3v20Zm2.622-17.336h27.756v14.672H5.622V58.664ZM59.169 24h2.662v-7.157H69v-2.666h-7.169V7H59.17v7.177H52v2.666h7.169z"
  })));
};

var SvgLogoHorizontal = function SvgLogoHorizontal(props) {
  return jsx("svg", _extends({
    id: "logo-horizontal_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 420.94 143.66",
    xmlSpace: "preserve"
  }, props), jsx("style", null, '.logo-horizontal_svg__st0{fill:#213c45}'), jsx("g", {
    id: "logo-horizontal_svg__XMLID_86_"
  }, jsx("path", {
    id: "logo-horizontal_svg__XMLID_116_",
    className: "logo-horizontal_svg__st0",
    d: "M93.2 72.66c2.1 0 3.31-.14 5.96-.7l.65 4.47c-2.05.56-4.33.84-6.62.84-10.2 0-13.14-6.38-13.14-13.84.09-7.27 4.47-13.42 13.09-13.42 2.28 0 4.24.28 6.62.89l-.89 4.43c-2.52-.56-4.01-.65-5.59-.65-5.4.09-8.06 4.1-8.15 8.76.01 4.61 1.73 9.22 8.07 9.22z"
  }), jsx("path", {
    id: "logo-horizontal_svg__XMLID_113_",
    className: "logo-horizontal_svg__st0",
    d: "M114.07 50.02c8.39.05 12.11 6.29 12.11 13.6 0 7.13-3.21 13.51-12.16 13.56-8.76-.09-12.11-6.43-12.11-13.56 0-7.31 3.77-13.51 12.16-13.6zm0 22.68c5.36-.05 7.08-4.38 7.08-9.08-.05-4.29-1.86-9.13-7.13-9.13-5.12.05-7.13 4.8-7.13 9.13 0 4.89 2.15 9.08 7.18 9.08z"
  }), jsx("path", {
    id: "logo-horizontal_svg__XMLID_111_",
    className: "logo-horizontal_svg__st0",
    d: "M160.88 76.71V59.94c0-4.24-1.58-5.4-4.24-5.4-1.82 0-3.87 1.03-5.73 2.56.09.56.14 1.68.14 2v17.61h-5.22V59.75c0-4.24-1.26-5.26-3.91-5.26-1.68 0-4.01 1.12-6.01 2.61v19.61h-5.17V50.48h5.17v2.24c1.58-1.26 4.1-2.7 6.85-2.75 3.63-.05 5.73 1.21 6.9 3.17 2.14-2 5.31-3.12 7.73-3.17 8.53-.14 8.66 6.71 8.66 9.6v17.14h-5.17z"
  }), jsx("path", {
    id: "logo-horizontal_svg__XMLID_109_",
    className: "logo-horizontal_svg__st0",
    d: "M201.87 76.71V59.94c0-4.24-1.58-5.4-4.24-5.4-1.82 0-3.87 1.03-5.73 2.56.09.56.14 1.68.14 2v17.61h-5.22V59.75c0-4.24-1.26-5.26-3.91-5.26-1.68 0-4.01 1.12-6.01 2.61v19.61h-5.17V50.48h5.17v2.24c1.58-1.26 4.1-2.7 6.85-2.75 3.63-.05 5.73 1.21 6.9 3.17 2.14-2 5.31-3.12 7.73-3.17 8.53-.14 8.66 6.71 8.66 9.6v17.14h-5.17z"
  }), jsx("path", {
    id: "logo-horizontal_svg__XMLID_106_",
    className: "logo-horizontal_svg__st0",
    d: "m231.17 71.91.79 4.24c-2.33.79-5.54 1.17-8.06 1.17-10.34 0-12.86-6.94-12.86-13.88s3.08-13.37 11.74-13.37c5.36 0 9.83 3.31 9.88 11.74l-.05 2.75h-16.49c.09 5.12 2.84 8.25 8.01 8.25 2.06-.01 4.2-.24 7.04-.9zm-14.81-11.36h11.51c-.19-5.31-2.84-6.38-5.31-6.38-3.92-.05-5.74 2.6-6.2 6.38z"
  }), jsx("path", {
    id: "logo-horizontal_svg__XMLID_104_",
    className: "logo-horizontal_svg__st0",
    d: "M251.67 55.28c-1.35-.33-2.52-.37-3.35-.37-3.21-.05-4.89 1.54-6.1 2.8v19.01h-5.17V50.48h5.17v2.33c1.35-1.4 3.4-2.61 6.06-2.66 1.07-.05 2.84.14 4.33.7l-.94 4.43z"
  }), jsx("path", {
    id: "logo-horizontal_svg__XMLID_102_",
    className: "logo-horizontal_svg__st0",
    d: "M266.8 72.66c2.1 0 3.31-.14 5.96-.7l.65 4.47c-2.05.56-4.33.84-6.62.84-10.2 0-13.14-6.38-13.14-13.84.09-7.27 4.47-13.42 13.09-13.42 2.28 0 4.24.28 6.62.89l-.89 4.43c-2.52-.56-4.01-.65-5.59-.65-5.4.09-8.06 4.1-8.15 8.76.01 4.61 1.74 9.22 8.07 9.22z"
  }), jsx("path", {
    id: "logo-horizontal_svg__XMLID_99_",
    className: "logo-horizontal_svg__st0",
    d: "m295.64 71.91.79 4.24c-2.33.79-5.54 1.17-8.06 1.17-10.34 0-12.86-6.94-12.86-13.88s3.08-13.37 11.74-13.37c5.36 0 9.83 3.31 9.88 11.74l-.05 2.75h-16.49c.09 5.12 2.84 8.25 8.01 8.25 2.05-.01 4.2-.24 7.04-.9zm-14.82-11.36h11.51c-.19-5.31-2.84-6.38-5.31-6.38-3.91-.05-5.73 2.6-6.2 6.38z"
  }), jsx("path", {
    id: "logo-horizontal_svg__XMLID_97_",
    className: "logo-horizontal_svg__st0",
    d: "M314.64 54.77h-7.13v12.72c0 2.65.33 4.52 3.03 4.89 1.49.14 3.03 0 4.52-.19l.33 4.47c-1.54.28-3.73.33-4.61.33-6.1-.23-8.39-3.35-8.39-8.25V54.77h-3.77v-3.59l3.77-.42v-6.1h5.12v5.82h7.13v4.29z"
  }), jsx("path", {
    id: "logo-horizontal_svg__XMLID_94_",
    className: "logo-horizontal_svg__st0",
    d: "M329.69 50.02c8.39.05 12.11 6.29 12.11 13.6 0 7.13-3.21 13.51-12.16 13.56-8.76-.09-12.11-6.43-12.11-13.56 0-7.31 3.77-13.51 12.16-13.6zm0 22.68c5.36-.05 7.08-4.38 7.08-9.08-.05-4.29-1.86-9.13-7.13-9.13-5.12.05-7.13 4.8-7.13 9.13 0 4.89 2.15 9.08 7.18 9.08z"
  }), jsx("path", {
    id: "logo-horizontal_svg__XMLID_91_",
    className: "logo-horizontal_svg__st0",
    d: "M357.54 50.02c8.39.05 12.11 6.29 12.11 13.6 0 7.13-3.21 13.51-12.16 13.56-8.76-.09-12.11-6.43-12.11-13.56 0-7.31 3.78-13.51 12.16-13.6zm0 22.68c5.36-.05 7.08-4.38 7.08-9.08-.05-4.29-1.86-9.13-7.13-9.13-5.12.05-7.13 4.8-7.13 9.13.01 4.89 2.15 9.08 7.18 9.08z"
  }), jsx("path", {
    id: "logo-horizontal_svg__XMLID_89_",
    className: "logo-horizontal_svg__st0",
    d: "M373.75 76.71V41.12h4.98v35.59h-4.98z"
  }), jsx("path", {
    id: "logo-horizontal_svg__XMLID_87_",
    className: "logo-horizontal_svg__st0",
    d: "M384 71.63c2.93.75 5.68 1.12 7.41 1.12 2.05 0 4.15-.42 4.29-2.89.14-2.61-2.56-3.4-5.64-4.7-3.49-1.44-7.27-3.4-7.17-8.25.09-2.42 1.54-7.17 9.27-6.94 2.33.05 5.12.42 7.45 1.03l-.88 4.29c-2.75-.65-4.8-.93-6.8-.98-2.24 0-3.96.7-4.05 2.8-.05 1.77 1.35 2.7 4.8 4.1 3.49 1.44 8.43 3.31 8.2 8.81-.14 3.49-2.42 7.31-9.46 7.22-2.24-.05-5.82-.33-8.48-1.26l1.06-4.35z"
  })), jsx("path", {
    className: "logo-horizontal_svg__st0",
    d: "M167.07 104.65h-1.83l-4.65-12.37h-.06c-.22 1.49-.46 2.9-.75 4.23l-1.74 8.14h-1.64l3.12-14.78h1.82l4.64 12.34h.06c.2-1.51.45-2.88.73-4.1l1.76-8.24h1.66l-3.12 14.78zm8 .21c-1.24 0-2.21-.37-2.92-1.1-.71-.73-1.06-1.75-1.06-3.05 0-1.27.25-2.48.75-3.65.5-1.16 1.17-2.07 2-2.71.83-.65 1.74-.97 2.74-.97 1.03 0 1.81.22 2.33.67s.78 1.07.78 1.88c0 1.21-.56 2.17-1.68 2.86s-2.72 1.04-4.8 1.04h-.33l-.04.81c0 .88.21 1.57.62 2.07.41.5 1.06.74 1.93.74.42 0 .86-.06 1.31-.18s1.01-.34 1.67-.67v1.48c-.63.3-1.19.5-1.68.62-.5.1-1.03.16-1.62.16zm1.41-10.04c-.69 0-1.35.32-1.96.95s-1.08 1.51-1.4 2.64h.12c1.54 0 2.71-.2 3.53-.6.82-.4 1.23-.98 1.23-1.74 0-.36-.12-.65-.37-.89-.24-.25-.63-.36-1.15-.36zm8.55 5.45-3.5 4.39h-1.97l4.8-5.71-2.42-5.37h1.72l1.76 4.17 3.34-4.17h1.96l-4.6 5.45 2.55 5.63h-1.7l-1.94-4.39zm9.17 3.2c.37 0 .86-.09 1.46-.26v1.3c-.23.09-.51.18-.85.24-.34.07-.61.1-.81.1-.84 0-1.49-.2-1.94-.6s-.67-1-.67-1.79c0-.44.06-.95.18-1.52l1.28-6.09h-1.74l.14-.74 1.87-.79 1.26-2.31h.99l-.56 2.55h2.77l-.26 1.28h-2.76l-1.3 6.11c-.12.59-.18 1.03-.18 1.33 0 .38.1.67.29.87s.48.32.83.32zm19.22-9.9-.25 1.08-2.13.24c.28.42.41.95.41 1.6 0 1.29-.39 2.31-1.18 3.08-.79.77-1.83 1.15-3.15 1.15-.37 0-.65-.03-.85-.08-.94.36-1.41.8-1.41 1.32 0 .28.11.46.33.55.22.09.55.16.97.22l1.18.14c1.22.15 2.1.45 2.65.89.55.44.82 1.1.82 1.96 0 1.24-.49 2.2-1.48 2.88-.98.68-2.37 1.02-4.16 1.02-1.31 0-2.33-.25-3.07-.74s-1.11-1.19-1.11-2.1c0-.71.24-1.32.73-1.84s1.27-.96 2.36-1.32c-.53-.28-.79-.68-.79-1.22 0-.46.17-.86.52-1.2.34-.33.82-.65 1.44-.94-.42-.22-.77-.53-1.04-.96s-.4-.91-.4-1.47c0-1.31.4-2.38 1.21-3.22.81-.84 1.83-1.25 3.09-1.25.53 0 1.04.07 1.56.2h3.75v.01zm-10.77 13.06c0 .52.22.93.66 1.23s1.09.46 1.95.46c1.23 0 2.19-.21 2.88-.64s1.04-1.03 1.04-1.81c0-.42-.18-.75-.55-.99-.36-.24-.98-.41-1.86-.51l-1.61-.16c-.81.17-1.43.47-1.86.89-.43.41-.65.93-.65 1.53zm2.81-8.85c0 .57.15 1.01.46 1.31.3.3.72.45 1.26.45.53 0 1-.14 1.4-.42s.7-.67.92-1.17c.21-.5.32-1.03.32-1.61 0-.55-.15-.97-.44-1.26-.3-.29-.72-.43-1.27-.43-.53 0-.99.14-1.38.41-.39.27-.7.65-.92 1.14-.24.48-.35 1.01-.35 1.58zm12.19 7.08c-1.24 0-2.21-.37-2.92-1.1s-1.06-1.75-1.06-3.05c0-1.27.25-2.48.75-3.65.5-1.16 1.17-2.07 2-2.71.83-.65 1.74-.97 2.74-.97 1.03 0 1.81.22 2.33.67s.78 1.07.78 1.88c0 1.21-.56 2.17-1.68 2.86s-2.72 1.04-4.8 1.04h-.33l-.04.81c0 .88.21 1.57.62 2.07.42.5 1.06.74 1.93.74.42 0 .86-.06 1.31-.18s1.01-.34 1.67-.67v1.48c-.63.3-1.19.5-1.68.62-.5.1-1.04.16-1.62.16zm1.4-10.04c-.69 0-1.35.32-1.96.95s-1.08 1.51-1.4 2.64h.12c1.54 0 2.71-.2 3.53-.6.82-.4 1.23-.98 1.23-1.74 0-.36-.12-.65-.37-.89-.23-.25-.62-.36-1.15-.36zm11.21 9.83 1.5-7c.13-.7.2-1.19.2-1.46 0-.42-.12-.76-.36-1.02s-.62-.38-1.15-.38c-.6 0-1.19.2-1.75.61-.57.4-1.07.98-1.51 1.73-.44.75-.76 1.65-.99 2.72l-1.02 4.8h-1.7l2.37-11.08h1.41l-.22 2.05h.1c.65-.82 1.27-1.4 1.88-1.74s1.23-.51 1.88-.51c.86 0 1.53.23 2.03.7.5.47.74 1.12.74 1.97 0 .53-.08 1.14-.23 1.82l-1.45 6.79h-1.73zm9.55.21c-1.24 0-2.21-.37-2.92-1.1s-1.06-1.75-1.06-3.05c0-1.27.25-2.48.75-3.65.5-1.16 1.17-2.07 2-2.71.83-.65 1.74-.97 2.74-.97 1.03 0 1.81.22 2.33.67s.78 1.07.78 1.88c0 1.21-.56 2.17-1.68 2.86s-2.72 1.04-4.8 1.04h-.33l-.04.81c0 .88.21 1.57.62 2.07.42.5 1.06.74 1.93.74.42 0 .86-.06 1.31-.18s1.01-.34 1.67-.67v1.48c-.63.3-1.19.5-1.68.62-.5.1-1.03.16-1.62.16zm1.41-10.04c-.69 0-1.35.32-1.96.95s-1.08 1.51-1.4 2.64h.12c1.54 0 2.71-.2 3.53-.6.82-.4 1.23-.98 1.23-1.74 0-.36-.12-.65-.37-.89-.24-.25-.63-.36-1.15-.36zm11.43-1.45c.46 0 .87.05 1.21.14l-.36 1.52a4.33 4.33 0 0 0-1.06-.13c-.61 0-1.19.2-1.72.61-.54.4-1 .97-1.41 1.68-.4.72-.7 1.52-.88 2.39l-1.08 5.08h-1.7l2.37-11.08h1.41l-.22 2.05h.1c.49-.64.89-1.1 1.2-1.38.32-.28.65-.5 1-.65.33-.15.72-.23 1.14-.23zm7.06 0c.62 0 1.17.17 1.66.5s.86.81 1.13 1.44h.11l.68-1.74h1.28l-2.36 11.08h-1.34l.26-2.11h-.08c-1.21 1.54-2.48 2.32-3.81 2.32-.94 0-1.67-.33-2.2-1s-.8-1.58-.8-2.74c0-1.4.24-2.7.72-3.9.48-1.2 1.14-2.14 1.98-2.82s1.76-1.03 2.77-1.03zm-1.92 10.08c.65 0 1.3-.31 1.95-.94.65-.62 1.17-1.44 1.58-2.44s.61-2 .61-3.01c0-.69-.19-1.25-.57-1.66s-.87-.62-1.49-.62c-.7 0-1.35.29-1.96.87s-1.08 1.36-1.42 2.36c-.34.99-.52 2.04-.52 3.13 0 .77.16 1.34.47 1.72.33.4.78.59 1.35.59zm11.15.02c.37 0 .86-.09 1.46-.26v1.3c-.23.09-.51.18-.85.24s-.61.1-.81.1c-.84 0-1.49-.2-1.94-.6s-.67-1-.67-1.79c0-.44.06-.95.18-1.52l1.28-6.09h-1.74l.14-.74 1.87-.79 1.26-2.31h.99l-.56 2.55h2.77l-.26 1.28h-2.76l-1.3 6.11c-.12.59-.18 1.03-.18 1.33 0 .38.1.67.29.87s.48.32.83.32zm5.02 1.18h-1.7l2.37-11.08h1.7l-2.37 11.08zm1.14-13.91c0-.38.11-.69.32-.92.21-.24.5-.36.84-.36.59 0 .89.3.89.91 0 .37-.11.68-.34.94s-.49.38-.78.38c-.27 0-.49-.08-.67-.25-.17-.16-.26-.39-.26-.7zm8.32 2.69c1.28 0 2.29.38 3.03 1.14s1.11 1.8 1.11 3.13a8.9 8.9 0 0 1-.73 3.59c-.49 1.13-1.14 2-1.97 2.61s-1.77.92-2.81.92c-1.29 0-2.31-.38-3.04-1.14s-1.1-1.8-1.1-3.12c0-1.28.25-2.49.74-3.61.49-1.13 1.16-2 1.99-2.6.84-.62 1.76-.92 2.78-.92zm2.39 4.04c0-.77-.21-1.4-.63-1.89-.42-.48-.99-.72-1.71-.72-.74 0-1.39.25-1.98.75-.58.5-1.04 1.19-1.36 2.08-.32.89-.48 1.87-.48 2.96 0 .88.21 1.57.64 2.05.43.48 1.04.72 1.85.72.7 0 1.33-.25 1.89-.74.56-.49 1-1.19 1.31-2.1.31-.91.47-1.95.47-3.11zm10.1 7.18 1.5-7c.13-.7.2-1.19.2-1.46 0-.42-.12-.76-.36-1.02s-.62-.38-1.15-.38c-.6 0-1.19.2-1.75.61-.57.4-1.07.98-1.51 1.73s-.76 1.65-.99 2.72l-1.02 4.8h-1.7l2.37-11.08h1.41l-.22 2.05h.1c.65-.82 1.27-1.4 1.88-1.74s1.23-.51 1.88-.51c.86 0 1.53.23 2.03.7.5.47.74 1.12.74 1.97 0 .53-.08 1.14-.23 1.82l-1.45 6.79h-1.73zm15.07.21c-1.31 0-2.32-.36-3.04-1.08s-1.08-1.74-1.08-3.05c0-1.35.25-2.59.75-3.73s1.19-2.03 2.07-2.66c.88-.64 1.87-.96 2.97-.96.92 0 1.83.17 2.71.52l-.48 1.43c-.81-.34-1.55-.52-2.21-.52-.75 0-1.44.26-2.07.77-.62.52-1.11 1.23-1.47 2.15s-.53 1.92-.53 3c0 .86.22 1.53.67 2.01s1.07.72 1.86.72c.49 0 .94-.07 1.38-.2s.86-.29 1.27-.48v1.45c-.84.41-1.77.63-2.8.63zm10.71-11.43c1.28 0 2.29.38 3.03 1.14s1.11 1.8 1.11 3.13a8.9 8.9 0 0 1-.73 3.59c-.49 1.13-1.14 2-1.97 2.61s-1.77.92-2.81.92c-1.29 0-2.31-.38-3.04-1.14s-1.1-1.8-1.1-3.12c0-1.28.25-2.49.74-3.61.49-1.13 1.16-2 1.99-2.6.84-.62 1.76-.92 2.78-.92zm2.39 4.04c0-.77-.21-1.4-.63-1.89-.42-.48-.99-.72-1.71-.72-.74 0-1.39.25-1.98.75-.58.5-1.04 1.19-1.36 2.08-.32.89-.48 1.87-.48 2.96 0 .88.21 1.57.64 2.05.43.48 1.04.72 1.85.72.7 0 1.33-.25 1.89-.74.56-.49 1-1.19 1.31-2.1.31-.91.47-1.95.47-3.11zm9.76 7.18 1.5-7c.12-.63.18-1.09.18-1.36 0-.47-.1-.84-.31-1.1s-.57-.39-1.07-.39c-.57 0-1.12.2-1.65.61-.54.4-1.01.98-1.42 1.73s-.72 1.66-.95 2.71l-1.02 4.8h-1.7l2.37-11.08h1.41l-.22 2.05h.1c.59-.8 1.17-1.38 1.75-1.73s1.18-.53 1.8-.53c.76 0 1.35.22 1.76.66s.65 1.05.73 1.83h.08c.58-.84 1.2-1.47 1.85-1.88.65-.41 1.31-.61 1.98-.61.86 0 1.52.23 1.99.69s.7 1.13.7 2c0 .46-.07 1.06-.22 1.8l-1.46 6.79h-1.72l1.5-7c.13-.7.2-1.19.2-1.48 0-.42-.12-.75-.35-1.01-.23-.25-.6-.38-1.1-.38-.55 0-1.08.2-1.62.59-.53.39-1 .95-1.4 1.66-.4.72-.71 1.57-.92 2.55l-1.08 5.06h-1.69v.02zm18.06 0 1.5-7c.12-.63.18-1.09.18-1.36 0-.47-.1-.84-.31-1.1s-.57-.39-1.07-.39c-.57 0-1.12.2-1.65.61-.54.4-1.01.98-1.42 1.73s-.72 1.66-.95 2.71l-1.02 4.8h-1.7l2.37-11.08h1.41l-.22 2.05h.1c.59-.8 1.17-1.38 1.75-1.73s1.18-.53 1.8-.53c.76 0 1.35.22 1.76.66s.65 1.05.73 1.83h.08c.58-.84 1.2-1.47 1.85-1.88.65-.41 1.31-.61 1.98-.61.86 0 1.52.23 1.99.69s.7 1.13.7 2c0 .46-.07 1.06-.22 1.8l-1.46 6.79h-1.72l1.5-7c.13-.7.2-1.19.2-1.48 0-.42-.12-.75-.35-1.01-.23-.25-.6-.38-1.1-.38-.55 0-1.08.2-1.62.59-.53.39-1 .95-1.4 1.66-.4.72-.71 1.57-.92 2.55l-1.08 5.06h-1.69v.02zm16 .21c-1.24 0-2.21-.37-2.92-1.1s-1.06-1.75-1.06-3.05c0-1.27.25-2.48.75-3.65.5-1.16 1.17-2.07 2-2.71.83-.65 1.74-.97 2.74-.97 1.03 0 1.81.22 2.33.67s.78 1.07.78 1.88c0 1.21-.56 2.17-1.68 2.86s-2.72 1.04-4.8 1.04h-.33l-.04.81c0 .88.21 1.57.62 2.07.42.5 1.06.74 1.93.74.42 0 .86-.06 1.31-.18s1.01-.34 1.67-.67v1.48c-.63.3-1.19.5-1.68.62-.5.1-1.03.16-1.62.16zm1.4-10.04c-.69 0-1.35.32-1.96.95s-1.08 1.51-1.4 2.64h.12c1.54 0 2.71-.2 3.53-.6s1.23-.98 1.23-1.74c0-.36-.12-.65-.37-.89-.23-.25-.62-.36-1.15-.36zm11.44-1.45c.46 0 .87.05 1.21.14l-.36 1.52a4.33 4.33 0 0 0-1.06-.13c-.61 0-1.19.2-1.72.61-.54.4-1 .97-1.41 1.68-.4.72-.7 1.52-.88 2.39l-1.08 5.08h-1.7l2.37-11.08h1.41l-.22 2.05h.1c.49-.64.89-1.1 1.2-1.38.32-.28.65-.5 1-.65.33-.15.71-.23 1.14-.23zm5.71 11.49c-1.31 0-2.32-.36-3.04-1.08s-1.08-1.74-1.08-3.05c0-1.35.25-2.59.75-3.73s1.19-2.03 2.07-2.66c.88-.64 1.87-.96 2.97-.96.92 0 1.83.17 2.71.52l-.48 1.43c-.81-.34-1.55-.52-2.21-.52-.75 0-1.44.26-2.07.77-.62.52-1.11 1.23-1.47 2.15s-.53 1.92-.53 3c0 .86.22 1.53.67 2.01s1.07.72 1.86.72c.49 0 .94-.07 1.38-.2s.86-.29 1.27-.48v1.45c-.84.41-1.77.63-2.8.63zm9.18 0c-1.24 0-2.21-.37-2.92-1.1s-1.06-1.75-1.06-3.05c0-1.27.25-2.48.75-3.65.5-1.16 1.17-2.07 2-2.71.83-.65 1.74-.97 2.74-.97 1.03 0 1.81.22 2.33.67s.78 1.07.78 1.88c0 1.21-.56 2.17-1.68 2.86s-2.72 1.04-4.8 1.04h-.33l-.04.81c0 .88.21 1.57.62 2.07.42.5 1.06.74 1.93.74.42 0 .86-.06 1.31-.18s1.01-.34 1.67-.67v1.48c-.63.3-1.19.5-1.68.62-.49.1-1.03.16-1.62.16zm1.41-10.04c-.69 0-1.35.32-1.96.95s-1.08 1.51-1.4 2.64h.12c1.54 0 2.71-.2 3.53-.6s1.23-.98 1.23-1.74c0-.36-.12-.65-.37-.89-.24-.25-.63-.36-1.15-.36z"
  }), jsx("g", {
    id: "logo-horizontal_svg__XMLID_1_"
  }, jsx("path", {
    className: "logo-horizontal_svg__st0",
    d: "M67.04 75.19 45.32 65.07c-.17-.08-.36-.14-.55-.19v-6.15c0-.6.02-.61.41-.79l.86-.4c1.46-.68 1.46-.68 10.02-4.69l10.98-5.14c.64-.3 1.05-.94 1.04-1.64 0-.7-.41-1.35-1.05-1.64L45.32 34.31a2.91 2.91 0 0 0-2.48 0L21.12 44.4c-.63.29-1.04.93-1.05 1.63V76.8c0 .7.41 1.35 1.04 1.64l21.75 10.18c.09.04.67.28 1.26.28.57 0 1.14-.23 1.24-.28l21.69-10.15c.64-.3 1.05-.94 1.04-1.64 0-.7-.41-1.34-1.05-1.64zM21.46 75V47.84l21.41 10.02c.18.08.36.15.55.19.01 0 .01.01.02.01-.03.2-.05.42-.05.66v6.14c-.01 0-.03.01-.04.01-.17.04-.34.1-.51.18L21.46 75zm.25-29.35 21.72-10.09a1.517 1.517 0 0 1 1.32 0l21.72 10.13a.43.43 0 0 1 0 .78l-10.98 5.14c-8.56 4.01-8.56 4.01-10.02 4.68l-.82.38c-.06.02-.12.04-.18.05a.31.31 0 0 1-.08.02c-.09.02-.19.02-.29.02-.22 0-.44-.05-.64-.15L21.7 46.43a.36.36 0 0 1-.1-.07.486.486 0 0 1-.15-.33c.01-.15.1-.31.26-.38zm-.01 31.54a.43.43 0 0 1-.25-.39c0-.04.01-.08.02-.12.03-.12.12-.22.23-.27l21.68-10.08v21.01L21.7 77.19zm44.76.04L44.77 87.38V66.34l21.69 10.11c.15.07.25.22.25.39 0 .16-.1.31-.25.39z"
  }), jsx("path", {
    className: "logo-horizontal_svg__st0",
    d: "M44.12 89.4c-.71 0-1.39-.29-1.46-.32L20.9 78.89a2.295 2.295 0 0 1-1.33-2.09V46.03c.01-.9.54-1.71 1.34-2.08l21.72-10.09a3.42 3.42 0 0 1 2.9 0l21.71 10.12c.81.37 1.34 1.19 1.34 2.09.01.88-.51 1.71-1.33 2.09L56.27 53.3c-8.56 4.01-8.56 4.01-10.02 4.69l-.86.4c-.05.02-.08.04-.12.05-.01.08-.01.21-.01.28v5.78c.09.03.18.07.26.11l21.72 10.12c.81.38 1.34 1.2 1.34 2.09.01.88-.51 1.71-1.33 2.09L45.57 89.07c-.16.08-.8.33-1.45.33zm-1.05-1.23s.53.23 1.05.23c.45 0 .94-.19 1.02-.23l21.7-10.15c.46-.22.76-.68.75-1.18 0-.51-.3-.98-.76-1.19L45.11 65.52c-.15-.07-.31-.12-.47-.16l-.37-.1v-6.54c0-.74.08-.96.7-1.24l.86-.4c1.46-.68 1.46-.68 10.02-4.69l10.98-5.14c.46-.22.76-.68.75-1.18 0-.52-.3-.98-.76-1.19L45.11 34.76c-.65-.31-1.4-.31-2.06 0L21.33 44.85c-.46.21-.75.67-.76 1.18V76.8c0 .5.3.98.75 1.19l21.75 10.18zm1.2 0V65.56L66.67 76c.33.15.54.48.54.84 0 .34-.2.66-.51.83l-.02.01-22.41 10.49zm1-21.05v19.47l20.89-9.78-20.89-9.69zm-1.39 21.01L21.49 77.64a.923.923 0 0 1-.54-.84c0-.1.02-.18.04-.24a.9.9 0 0 1 .51-.6l22.39-10.41v22.58zM22.05 76.8l20.83 9.75V67.11L22.05 76.8zm-1.09-1.02V47.05L43.08 57.4c.1.05.25.11.39.14l.54.01-.09.57c-.03.18-.04.37-.04.59v6.56l-.36.06-.1.03c-.12.03-.25.08-.38.14L20.96 75.78zm1-27.15v25.59l20.67-9.62c.09-.04.17-.08.26-.11v-5.77c0-.11 0-.21.01-.31-.09-.03-.16-.07-.23-.1l-20.71-9.68zm22.14 8.63c-.3 0-.6-.07-.86-.2L21.49 46.88c-.1-.05-.18-.1-.24-.17-.16-.14-.27-.38-.29-.65.02-.42.24-.73.55-.87L43.23 35.1a2.06 2.06 0 0 1 1.75 0L66.7 45.23a.923.923 0 0 1 0 1.68l-11 5.15c-8.56 4.01-8.56 4.01-10.02 4.68l-.82.38c-.14.05-.22.08-.31.09l-.05.01v.01c-.15.03-.28.03-.4.03zM21.98 46.08l21.69 10.08c.2.1.5.12.61.09l.11-.01c.03-.02.07-.03.1-.04l.77-.36c1.46-.67 1.46-.67 10.02-4.68l10.85-5.08-21.59-10.07a.995.995 0 0 0-.89 0L21.98 46.08z"
  })));
};

var SvgLogo = function SvgLogo(props) {
  return jsx("svg", _extends({
    viewBox: "0 0 34 34",
    width: 34,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "m30.377 24.992-12.662-5.903a1.888 1.888 0 0 0-.319-.11v-3.581c0-.35.013-.356.239-.46l.503-.234c.849-.394.849-.394 5.84-2.73l6.4-2.997c.37-.173.609-.55.609-.958 0-.41-.24-.785-.61-.958l-12.663-5.9a1.71 1.71 0 0 0-1.445-.002L3.612 7.044A1.066 1.066 0 0 0 3 7.996v17.935c0 .41.238.785.608.957l12.677 5.935c.099.047.2.08.306.107v.045l.394.007h.034l.377.004v-.047c.117-.026.233-.066.342-.116l12.64-5.918c.37-.172.609-.55.609-.957 0-.408-.24-.783-.61-.956zm-26.571-.11V9.053l12.48 5.842c.104.049.21.087.322.113.003 0 .007.004.01.004a2.25 2.25 0 0 0-.026.386v3.58l-.024.007c-.101.027-.2.058-.297.104L3.806 24.883zM3.95 7.776 16.61 1.89a.908.908 0 0 1 .764 0l12.66 5.903a.253.253 0 0 1 0 .456l-6.397 2.995c-4.992 2.336-4.992 2.336-5.839 2.73l-.477.222c-.036.014-.071.021-.107.03l-.049.014a.911.911 0 0 1-.539-.073L3.95 8.228a.207.207 0 0 1-.058-.037.252.252 0 0 1 .058-.417zm0 18.385a.253.253 0 0 1 0-.456l12.639-5.875v12.248L3.95 26.16zm26.087.017-12.64 5.917h-.003V19.83l12.64 5.891a.253.253 0 0 1 .003.457z",
    fill: "#2A4148"
  }));
};

var SvgMerchantCenterSmall = function SvgMerchantCenterSmall(props) {
  return jsx("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, jsx("g", {
    fill: "#003037",
    fillRule: "nonzero"
  }, jsx("path", {
    d: "M3.81 3.994c.003-.637.501-1.152 1.114-1.152h15.133c.612 0 1.109.516 1.109 1.152v7.478H22V3.994c-.003-1.1-.86-1.99-1.918-1.994H4.924C3.865 2.004 3.007 2.893 3 3.994V15h.81V3.994Z"
  }), jsx("path", {
    d: "M12 5h2v1h-2zM1 17.422C1 19.398 2.537 21 4.432 21H12v-.844H4.432c-1.291-.003-2.39-.982-2.591-2.312H12V17H1v.422ZM19.494 17A1.5 1.5 0 1 0 21 18.5a1.506 1.506 0 0 0-1.506-1.5Zm0 2.21a.71.71 0 1 1 .012-1.42.71.71 0 0 1-.012 1.42Z"
  }), jsx("path", {
    d: "M22.689 18.5c.006-.12.006-.239 0-.358L24 16.709l-1.033-1.918-1.813.48a3.44 3.44 0 0 0-.604-.352L20.036 13h-2.072l-.52 1.919a3.38 3.38 0 0 0-.604.351l-1.813-.48L14 16.71l1.335 1.432v.716l-1.329 1.433 1.027 1.918 1.813-.486c.19.14.392.26.604.358L17.97 24h2.06l.514-1.919c.211-.1.413-.22.604-.358l1.813.486 1.033-1.918-1.311-1.433c.008-.119.01-.239.006-.358Zm.314 1.919-.417.799-1.62-.428-.156.127c-.22.185-.464.334-.725.442l-.176.076-.459 1.702h-.894l-.46-1.702-.18-.076a2.859 2.859 0 0 1-.726-.442l-.15-.127-1.62.428-.441-.806 1.166-1.279-.03-.192a3.611 3.611 0 0 1-.03-.441c0-.148.01-.295.03-.441l.03-.205-1.166-1.279.44-.8 1.62.43.151-.129c.22-.183.465-.332.725-.441l.182-.077.459-1.701h.876l.46 1.701.174.077c.264.108.51.256.732.441l.15.128 1.638-.422.435.8-1.16 1.278v.205a2.704 2.704 0 0 1 0 .883v.204l1.142 1.267Z"
  }))));
};

var SvgMerchantCenter = function SvgMerchantCenter(props) {
  return jsx("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, jsx("g", {
    fill: "#003037",
    fillRule: "nonzero"
  }, jsx("path", {
    d: "M12.6 11.135a3.572 3.572 0 0 1 3.578-3.545h48.584a3.552 3.552 0 0 1 3.559 3.545v23.008H71V11.135C70.989 7.751 68.238 5.011 64.842 5H16.178c-3.4.01-6.156 2.748-6.178 6.135V45h2.6V11.135Z"
  }), jsx("path", {
    d: "M38 12h5v3h-5zM3 52.266C3 58.194 7.89 63 13.92 63H38v-2.532H13.92c-4.108-.008-7.602-2.947-8.244-6.936H38V51H3v1.266ZM60.98 52A5 5 0 1 0 66 57a5.02 5.02 0 0 0-5.02-5Zm0 7.368a2.368 2.368 0 1 1 .04-4.736 2.368 2.368 0 0 1-.04 4.736Z"
  }), jsx("path", {
    d: "M72.673 57c.02-.369.02-.738 0-1.107L77 51.465l-3.41-5.93-5.982 1.482a11.556 11.556 0 0 0-1.993-1.087L63.92 40h-6.84l-1.714 5.93c-.7.295-1.368.66-1.994 1.087l-5.982-1.482-3.39 5.93 4.407 4.428v2.214l-4.387 4.428 3.39 5.93 5.982-1.502c.625.434 1.293.805 1.993 1.107L57.1 74h6.8l1.695-5.93a12.513 12.513 0 0 0 1.994-1.107l5.981 1.502 3.41-5.93-4.327-4.428c.027-.368.033-.738.02-1.107Zm1.037 5.93-1.376 2.471-5.344-1.324-.518.395a9.232 9.232 0 0 1-2.393 1.364l-.578.237-1.516 5.258h-2.95l-1.516-5.258-.598-.237a9.572 9.572 0 0 1-2.393-1.364l-.498-.395-5.344 1.324-1.456-2.49 3.849-3.954-.1-.593a10.466 10.466 0 0 1-.1-1.364c.002-.456.035-.912.1-1.364l.1-.633-3.849-3.953 1.456-2.47 5.344 1.323.498-.395a9.572 9.572 0 0 1 2.393-1.364l.598-.237 1.515-5.258h2.892l1.515 5.258.578.237a9.353 9.353 0 0 1 2.413 1.364l.499.395 5.403-1.304 1.436 2.47-3.829 3.954v.633a7.84 7.84 0 0 1 0 2.728v.632l3.769 3.914Z"
  }))));
};

var SvgOpenSourceSmall = function SvgOpenSourceSmall(props) {
  return jsx("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), jsx("defs", null, jsx("path", {
    id: "open-source-small_svg__a",
    d: "M0 0h6v11H0z"
  }), jsx("path", {
    id: "open-source-small_svg__c",
    d: "M0 0h11v6H0z"
  })), jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, jsx("g", {
    transform: "translate(1 1)"
  }, jsx("mask", {
    id: "open-source-small_svg__b",
    fill: "#fff"
  }, jsx("use", {
    xlinkHref: "#open-source-small_svg__a"
  })), jsx("path", {
    d: "M3 .8c1.23 0 2.227 1.01 2.227 2.256 0 1.247-.997 2.257-2.227 2.257S.773 4.303.773 3.056C.773 1.81 1.77.8 3 .8m-.386 5.254V11h.772V6.053c1.643-.216 2.802-1.74 2.589-3.405C5.76.984 4.257-.19 2.614.026.97.242-.188 1.766.025 3.43a3.02 3.02 0 0 0 2.589 2.622",
    fill: "#003037",
    mask: "url(#open-source-small_svg__b)"
  })), jsx("path", {
    d: "M20.953 1.772c1.247 0 2.259.998 2.259 2.228 0 1.23-1.012 2.228-2.26 2.228-1.247 0-2.259-.998-2.259-2.228 0-1.23 1.012-2.228 2.26-2.228m0 5.228c1.68.002 3.045-1.338 3.047-2.995.002-1.657-1.357-3.003-3.038-3.005-1.53-.002-2.825 1.117-3.022 2.614H13v.772h4.952c.183 1.495 1.473 2.619 3 2.614",
    fill: "#003037"
  }), jsx("g", {
    transform: "translate(1 18)"
  }, jsx("mask", {
    id: "open-source-small_svg__d",
    fill: "#fff"
  }, jsx("use", {
    xlinkHref: "#open-source-small_svg__c"
  })), jsx("path", {
    d: "M3.047 5.228C1.8 5.228.788 4.23.788 3 .788 1.77 1.8.772 3.048.772 4.294.772 5.306 1.77 5.306 3c0 1.23-1.012 2.228-2.26 2.228m0-5.228C1.367-.002.002 1.338 0 2.995-.002 4.652 1.357 5.998 3.038 6c1.53.002 2.825-1.117 3.022-2.614H11v-.742H6.048c-.17-1.508-1.463-2.647-3-2.644",
    fill: "#003037",
    mask: "url(#open-source-small_svg__d)"
  })), jsx("path", {
    d: "M20.97 23.2c-1.23 0-2.227-1.01-2.227-2.256 0-1.247.997-2.257 2.227-2.257s2.228 1.01 2.228 2.257c0 1.246-.998 2.256-2.228 2.256Zm.386-5.253V13h-.742v4.947c-1.643.216-2.802 1.74-2.589 3.405.214 1.664 1.718 2.838 3.361 2.622 1.643-.216 2.802-1.74 2.589-3.405a3.02 3.02 0 0 0-2.589-2.622h-.03ZM11 16.801 13.283 8l.717.199L11.717 17zM16.482 15 19 11.997 16.482 9 16 9.574l2.037 2.423L16 14.426zM9 14.426l-2.035-2.43L9 9.575 8.523 9 6 11.997 8.523 15z",
    fill: "#003037"
  })));
};

var SvgOpenSource = function SvgOpenSource(props) {
  return jsx("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), jsx("defs", null, jsx("path", {
    id: "open-source_svg__a",
    d: "M0 0h19v35H0z"
  }), jsx("path", {
    id: "open-source_svg__c",
    d: "M0 0h35v19H0z"
  })), jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, jsx("g", {
    transform: "translate(3 3)"
  }, jsx("mask", {
    id: "open-source_svg__b",
    fill: "#fff"
  }, jsx("use", {
    xlinkHref: "#open-source_svg__a"
  })), jsx("path", {
    d: "M9.5 2.544c3.895 0 7.054 3.215 7.054 7.18 0 3.966-3.159 7.181-7.054 7.181-3.895 0-7.054-3.215-7.054-7.18 0-3.966 3.159-7.181 7.054-7.181M8.277 19.26V35h2.446V19.26c5.202-.687 8.872-5.537 8.197-10.834C18.245 3.13 13.48-.606 8.277.081 3.075.77-.595 5.62.08 10.915c.555 4.353 3.922 7.78 8.197 8.345",
    fill: "#003037",
    mask: "url(#open-source_svg__b)"
  })), jsx("path", {
    d: "M67.304 5.446c3.97 0 7.189 3.158 7.189 7.054 0 3.896-3.219 7.054-7.189 7.054s-7.189-3.158-7.189-7.054c0-3.896 3.219-7.054 7.189-7.054m0 16.554c5.346.007 9.688-4.238 9.696-9.485.008-5.247-4.319-9.507-9.665-9.515-4.871-.008-8.989 3.537-9.616 8.277H42v2.446h15.757c.583 4.735 4.686 8.292 9.547 8.277",
    fill: "#003037"
  }), jsx("g", {
    transform: "translate(3 58)"
  }, jsx("mask", {
    id: "open-source_svg__d",
    fill: "#fff"
  }, jsx("use", {
    xlinkHref: "#open-source_svg__c"
  })), jsx("path", {
    d: "M9.696 16.554c-3.97 0-7.189-3.158-7.189-7.054 0-3.896 3.219-7.054 7.189-7.054s7.189 3.158 7.189 7.054c0 3.896-3.219 7.054-7.189 7.054M9.696 0C4.35-.008.008 4.238 0 9.485-.008 14.732 4.319 18.992 9.665 19c4.871.008 8.989-3.537 9.616-8.277H35V8.37H19.243C18.703 3.6 14.59-.009 9.696 0",
    fill: "#003037",
    mask: "url(#open-source_svg__d)"
  })), jsx("path", {
    d: "M67.406 74.456c-3.896 0-7.054-3.215-7.054-7.18 0-3.966 3.158-7.181 7.054-7.181 3.895 0 7.054 3.215 7.054 7.18 0 3.966-3.159 7.181-7.054 7.181Zm1.223-16.716V42h-2.352v15.74c-5.202.687-8.872 5.537-8.197 10.834.675 5.296 5.44 9.032 10.643 8.344 5.202-.687 8.872-5.537 8.197-10.834-.555-4.352-3.922-7.78-8.197-8.344h-.094ZM35 54.337 42.609 25l2.391.663L37.391 55zM50.766 48 60 38.49 50.766 29 49 30.819l7.468 7.671L49 46.181zM31 46.181l-7.462-7.69L31 30.818 29.25 29 20 38.49 29.25 48z",
    fill: "#003037"
  })));
};

var SvgReleaseNotes = function SvgReleaseNotes(props) {
  return jsx("svg", _extends({
    viewBox: "0 0 12 12",
    width: 12,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "m9.144 2.17 1.068-1.066a.486.486 0 0 1 .645.04.49.49 0 0 1 .039.646L9.832 2.857a.486.486 0 0 1-.689 0 .49.49 0 0 1 0-.69v.004zM7.67.045a.905.905 0 0 0-.485-.02.58.58 0 0 0-.354.22l-.78 1.19c-.128.195-.006.422.28.521.236.08.525.051.714-.073.056-.037.1-.08.131-.128L7.95.564c.127-.195.005-.422-.28-.52zm3.765 4.001-1.205.78c-.197.145-.283.498-.196.801.087.304.317.45.522.334l1.205-.787a.454.454 0 0 0 .128-.13.87.87 0 0 0 .039-.774c-.11-.24-.314-.333-.493-.224zm-.603 3.468a.572.572 0 1 1-.81.81l-.336-.336L4.253 10.4l-1.545.686a.568.568 0 0 1-.05.747.574.574 0 0 1-.81 0L.16 10.146a.57.57 0 0 1 .746-.858L4.01 2.312l-.336-.336a.572.572 0 0 1 .809-.808l6.35 6.345z",
    fill: "#999"
  }));
};

var SvgRibbon = function SvgRibbon(props) {
  return jsx("svg", _extends({
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M12.322 2h-8.63C3.304 2 3 2.278 3 2.632v10.736c0 .227.138.442.36.555a.705.705 0 0 0 .705-.038l3.942-2.4 3.928 2.413a.68.68 0 0 0 .387.101.69.69 0 0 0 .318-.076.636.636 0 0 0 .36-.555V2.632c.013-.354-.29-.632-.678-.632z",
    fill: "#E6E6E6",
    fillRule: "evenodd"
  }));
};

var SvgRss = function SvgRss(props) {
  return jsx("svg", _extends({
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M10.933 12.4A7.333 7.333 0 0 0 3.6 5.067V3.6a8.8 8.8 0 0 1 8.8 8.8h-1.467zm-2.533 0a4.8 4.8 0 0 0-4.8-4.8V6a6.4 6.4 0 0 1 6.4 6.4H8.4zm-3.2 0a1.6 1.6 0 1 1 0-3.2 1.6 1.6 0 0 1 0 3.2zM11.75 2h-7.5A2.25 2.25 0 0 0 2 4.25v7.5A2.25 2.25 0 0 0 4.25 14h7.5A2.25 2.25 0 0 0 14 11.75v-7.5A2.25 2.25 0 0 0 11.75 2z",
    fill: "#999",
    fillRule: "evenodd"
  }));
};

var SvgSearch = function SvgSearch(props) {
  return jsx("svg", _extends({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M5.556 12.14a4.832 4.832 0 0 1 0-4.81A4.782 4.782 0 0 1 9.7 4.924c1.71 0 3.29.917 4.145 2.406a4.832 4.832 0 0 1 0 4.81A4.782 4.782 0 0 1 9.7 14.547c-1.71 0-3.29-.917-4.145-2.405m15.18 7.427-5.713-5.742a6.752 6.752 0 0 0 .48-7.458A6.694 6.694 0 0 0 9.702 3a6.694 6.694 0 0 0-5.803 3.368 6.765 6.765 0 0 0 0 6.735 6.676 6.676 0 0 0 9.85 2l5.715 5.745a.896.896 0 0 0 1.273 0 .909.909 0 0 0 0-1.28",
    fillRule: "evenodd"
  }));
};

var SvgSlash = function SvgSlash(props) {
  return jsx("svg", _extends({
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("g", {
    fill: "none",
    fillRule: "evenodd"
  }, jsx("rect", {
    stroke: "#CCC",
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 2
  }), jsx("path", {
    fill: "#999",
    fillRule: "nonzero",
    d: "m7.211 12 2.657-7.139h-1.08L6.129 12z"
  })));
};

var SvgStackedLinesIndentedIcon = function SvgStackedLinesIndentedIcon(props) {
  return jsx("svg", _extends({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M6 7h12v2H6zm0 3h10v2H6zm0 3h10v2H6zm0 3h8v2H6z",
    fill: "#1A1A1A",
    fillRule: "evenodd"
  }));
};

var SvgTutorialsSmall = function SvgTutorialsSmall(props) {
  return jsx("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("g", {
    fill: "#003037",
    fillRule: "nonzero"
  }, jsx("path", {
    d: "M21.573 6H3.427A2.436 2.436 0 0 0 1 8.44v12.127A2.436 2.436 0 0 0 3.427 23h18.146A2.436 2.436 0 0 0 24 20.567V8.439A2.436 2.436 0 0 0 21.573 6Zm1.603 14.567a1.611 1.611 0 0 1-1.603 1.607H3.427a1.611 1.611 0 0 1-1.603-1.607V8.439c0-.888.716-1.61 1.603-1.613h18.146a1.612 1.612 0 0 1 1.603 1.613v12.128Z"
  }), jsx("path", {
    d: "m10 19 6-4-6-4v8Zm.809-6.446L14.456 15l-3.647 2.453v-4.899ZM5 2h15v1H5z"
  })));
};

var SvgTutorials = function SvgTutorials(props) {
  return jsx("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("g", {
    fill: "#003037",
    fillRule: "nonzero"
  }, jsx("path", {
    d: "M69.087 19H9.913C5.54 19.011 2 22.542 2 26.892v39.236c.011 4.343 3.548 7.86 7.913 7.872h59.174c4.365-.011 7.902-3.529 7.913-7.872V26.892c0-4.35-3.54-7.88-7.913-7.892Zm5.227 47.128c-.011 2.867-2.345 5.189-5.227 5.2H9.913c-2.882-.011-5.216-2.333-5.227-5.2V26.892c0-2.875 2.337-5.209 5.227-5.22h59.174c2.89.011 5.227 2.345 5.227 5.22v39.236Z"
  }), jsx("path", {
    d: "m32 59 20-12-20-12v24Zm2.695-19.338L46.853 47l-12.158 7.358V39.662ZM15 6h48v3H15z"
  })));
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  HttpApiSmallSvgIcon: SvgHttpApiSmall,
  HttpApiSvgIcon: SvgHttpApi,
  CtLogoSvgIcon: SvgCtLogo,
  CustomApplicationSmallSvgIcon: SvgCustomApplicationSmall,
  CustomApplicationSvgIcon: SvgCustomApplication,
  LogoHorizontalSvgIcon: SvgLogoHorizontal,
  LogoSvgIcon: SvgLogo,
  MerchantCenterSmallSvgIcon: SvgMerchantCenterSmall,
  MerchantCenterSvgIcon: SvgMerchantCenter,
  OpenSourceSmallSvgIcon: SvgOpenSourceSmall,
  OpenSourceSvgIcon: SvgOpenSource,
  ReleaseNotesSvgIcon: SvgReleaseNotes,
  RibbonSvgIcon: SvgRibbon,
  RssSvgIcon: SvgRss,
  SearchSvgIcon: SvgSearch,
  SlashSvgIcon: SvgSlash,
  StackedLinesIndentedIconSvgIcon: SvgStackedLinesIndentedIcon,
  TutorialsSmallSvgIcon: SvgTutorialsSmall,
  TutorialsSvgIcon: SvgTutorials
});

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"]; if (!it) { if (_Array$isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$1(o, minLen) { var _context2; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = _sliceInstanceProperty(_context2 = Object.prototype.toString.call(o)).call(_context2, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* eslint-disable */
// From https://github.com/euank/node-parse-numeric-range
// The package does not ship with CommonJS modules, so we just copy over the implementation.
function parsePart(string) {
  var _context;

  var res = [],
      m;

  var _iterator = _createForOfIteratorHelper$1(_mapInstanceProperty(_context = string.split(',')).call(_context, function (str) {
    return _trimInstanceProperty(str).call(str);
  })),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var str = _step.value;

      // just a number
      if (/^-?\d+$/.test(str)) {
        res.push(_parseInt(str, 10));
      } else if (m = str.match(/^(-?\d+)(-|\.\.\.?|\u2025|\u2026|\u22EF)(-?\d+)$/)) {
        // 1-5 or 1..5 (equivilant) or 1...5 (doesn't include 5)
        var _m = m,
            _m2 = _slicedToArray(_m, 4),
            _ = _m2[0],
            lhs = _m2[1],
            sep = _m2[2],
            rhs = _m2[3];

        if (lhs && rhs) {
          lhs = _parseInt(lhs);
          rhs = _parseInt(rhs);
          var incr = lhs < rhs ? 1 : -1; // Make it inclusive by moving the right 'stop-point' away by one.

          if (sep === '-' || sep === '..' || sep === "\u2025") rhs += incr;

          for (var i = lhs; i !== rhs; i += incr) {
            res.push(i);
          }
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return res;
}

function ownKeys$5(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var _context4, _context5; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context4 = ownKeys$5(Object(source), !0)).call(_context4, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context5 = ownKeys$5(Object(source))).call(_context5, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"]; if (!it) { if (_Array$isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { var _context3; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context3 = Object.prototype.toString.call(o)).call(_context3, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, void 0, groups); }; var _super = RegExp.prototype, _groups = new _WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype); } function buildGroups(result, re) { var _context2; var g = _groups.get(re); return _reduceInstanceProperty(_context2 = _Object$keys(g)).call(_context2, function (groups, name) { return groups[name] = result[g[name]], groups; }, _Object$create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); return result && (result.groups = buildGroups(result, this)), result; }, BabelRegExp.prototype[_Symbol$replace] = function (str, substitution) { if ("string" == typeof substitution) { var groups = _groups.get(this); return _super[_Symbol$replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } if ("function" == typeof substitution) { var _this = this; return _super[_Symbol$replace].call(this, str, function () { var args = arguments; return "object" != typeof args[args.length - 1] && (args = _sliceInstanceProperty([]).call(args)).push(buildGroups(args, _this)), substitution.apply(this, args); }); } return _super[_Symbol$replace].call(this, str, substitution); }, _wrapRegExp.apply(this, arguments); }
var defaultOptions = {
  title: '',
  highlightLines: [],
  noPromptLines: [],
  secondaryTheme: false
};

var getLinesForRange = function getLinesForRange(value) {
  var _context;

  return value && typeof value === 'string' ? _filterInstanceProperty(_context = parsePart(_trimInstanceProperty(value).call(value))).call(_context, function (n) {
    return n > 0;
  }) : [];
}; // We need to parse the `metastring` value on our own as the default
// MDX implementation does not support values with whitespaces.
// https://github.com/mdx-js/mdx/blob/e95e2c114bead01164a8af068ae052cebf1534c2/packages/mdx/mdx-ast-to-mdx-hast.js#L38-L46
// We mostly need this for things like `title="This is a title"`.
// returns one match per attribute-value pair, containing named capture groups
// "attribute" and either one of the "value_*" groups
// Saved here for testing and editing: https://regex101.com/r/DKJjaO/1


var parseOptionsRegex = /*#__PURE__*/_wrapRegExp(/([0-9A-Z_a-z]+)(="(.*?)"|='(.*?)'|=([\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uFEFE\uFF00-\uFFFF]*)|)/g, {
  attribute: 1,
  value_doublequote: 3,
  value_singlequote: 4,
  value_noquote: 5
});

var parseOptionsString = function parseOptionsString(optionsString) {
  var parsedOptions = {};

  var matches = _Array$from(_matchAllInstanceProperty(optionsString).call(optionsString, parseOptionsRegex));

  var _iterator = _createForOfIteratorHelper(matches),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _match$groups;

      var match = _step.value;

      if (match !== null && match !== void 0 && (_match$groups = match.groups) !== null && _match$groups !== void 0 && _match$groups.attribute) {
        var _match$groups2, _match$groups3, _match$groups4;

        parsedOptions[match.groups.attribute] = (match === null || match === void 0 ? void 0 : (_match$groups2 = match.groups) === null || _match$groups2 === void 0 ? void 0 : _match$groups2.value_doublequote) || (match === null || match === void 0 ? void 0 : (_match$groups3 = match.groups) === null || _match$groups3 === void 0 ? void 0 : _match$groups3.value_singlequote) || (match === null || match === void 0 ? void 0 : (_match$groups4 = match.groups) === null || _match$groups4 === void 0 ? void 0 : _match$groups4.value_noquote) || true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return parsedOptions;
};

function parseCodeBlockOptions() {
  var _rawOptions$title;

  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    metastring: ''
  };
  if (!props.metastring) return defaultOptions;
  var rawOptions = parseOptionsString(props.metastring);
  if (rawOptions.secondaryTheme === 'false') rawOptions.secondaryTheme = false; // Boolean("false") = true

  return _objectSpread$5(_objectSpread$5({}, defaultOptions), {}, {
    title: (_rawOptions$title = rawOptions.title) === null || _rawOptions$title === void 0 ? void 0 : _rawOptions$title.toString(),
    highlightLines: getLinesForRange(rawOptions.highlightLines),
    noPromptLines: getLinesForRange(rawOptions.noPromptLines),
    secondaryTheme: Boolean(rawOptions.secondaryTheme)
  });
}

var _context$1;

function ownKeys$4(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var _context2, _context3; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context2 = ownKeys$4(Object(source), !0)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context3 = ownKeys$4(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var commercetoolsTheme = _objectSpread$4({}, nightOwl); // for the defaults see
// https://github.com/FormidableLabs/prism-react-renderer/blob/master/src/themes/nightOwl.js
// current changes:
// - less "neon" variation of the "string", new: rgb(192,228,139)
// - swap "property" and "string"/"url"/"inserted"/"attr-name" to make typical code less "glaring"
//   and to hightlight the property keys in JSON which eases understanding the structure.
// need to recreate this prismic type, it's not exported.


var italicStyle$1 = 'italic';
var additionalStyles$1 = [{
  types: ['string', 'url'],
  style: {
    color: 'rgb(128, 203, 196)'
  }
}, {
  types: ['inserted', 'attr-name'],
  style: {
    color: 'rgb(128, 203, 196)',
    fontStyle: italicStyle$1
  }
}, {
  types: ['property'],
  style: {
    color: 'rgb(192,228,139)'
  }
}];
commercetoolsTheme.styles = _concatInstanceProperty(_context$1 = []).call(_context$1, _toConsumableArray(nightOwl.styles), additionalStyles$1);

var _context;

function ownKeys$3(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var _context2, _context3; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context2 = ownKeys$3(Object(source), !0)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context3 = ownKeys$3(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var commercetoolsLightTheme = _objectSpread$3({}, nightOwlLight); // Goal: Optimize JSON, leave others alone.
// variations:
// - swap rgb(72, 118, 214)  and rgb(12, 150, 155) to have string literals
//   in green in both light and dark because they occur side by side in API docs.
// - booleans and numbers in a tone that's visually similar to the dark variant.
// need to recreate this prismic type, it's not exported.


var italicStyle = 'italic';
var additionalStyles = [{
  types: ['operator', 'keyword', 'property', 'namespace'],
  style: {
    color: 'rgb(72, 118, 214)'
  }
}, {
  types: ['inserted', 'attr-name'],
  style: {
    color: 'rgb(12, 150, 155)',
    fontStyle: italicStyle
  }
}, {
  types: ['string', 'builtin', 'char', 'constant', 'url'],
  style: {
    color: 'rgb(12, 150, 155)'
  }
}, {
  types: ['boolean'],
  style: {
    color: 'rgb(255, 20, 40)'
  }
}, {
  types: ['number'],
  style: {
    color: 'rgb(247, 70, 54)'
  }
}];
commercetoolsLightTheme.styles = _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(commercetoolsLightTheme.styles), additionalStyles);

var getSelection = function getSelection(document) {
  var selection = document.getSelection();
  return selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : false;
};

var createTextArea = function createTextArea(document, text) {
  var el = document.createElement('textarea');
  el.value = text;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px'; // Move outside the screen to make it invisible

  return el;
};

var copyToClipboard = function copyToClipboard(text) {
  var el = createTextArea(document, text);
  var selected = getSelection(document);
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);

  if (selected) {
    var _document$getSelectio, _document$getSelectio2;

    (_document$getSelectio = document.getSelection()) === null || _document$getSelectio === void 0 ? void 0 : _document$getSelectio.removeAllRanges();
    (_document$getSelectio2 = document.getSelection()) === null || _document$getSelectio2 === void 0 ? void 0 : _document$getSelectio2.addRange(selected);
  }
};

function ownKeys$2(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var _context4, _context5; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context4 = ownKeys$2(Object(source), !0)).call(_context4, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context5 = ownKeys$2(Object(source))).call(_context5, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var HighlightedContainer = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1vt669h2"
} : {
  target: "e1vt669h2",
  label: "HighlightedContainer"
})("background-color:", function (props) {
  return props.theme.codeBlockColors.surface;
}, ";border-radius:", tokens.borderRadiusForCodeBlock, ";margin:0;padding:", dimensions.spacings.s, " ", dimensions.spacings.xs, " ", dimensions.spacings.s, " ", dimensions.spacings.m, ";overflow:auto;");

var Preformatted = _styled("pre", process.env.NODE_ENV === "production" ? {
  target: "e1vt669h1"
} : {
  target: "e1vt669h1",
  label: "Preformatted"
})("font-family:", typography.fontFamilies.code, ";font-size:", typography.fontSizes.small, ";background-color:", function (props) {
  return props.theme.codeBlockColors.surface;
}, "!important;margin:0;padding:0;width:100%;white-space:pre-wrap;");

var CopyArea = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1vt669h0"
} : {
  target: "e1vt669h0",
  label: "CopyArea"
})("cursor:pointer;svg{fill:", function (props) {
  return props.theme.codeBlockColors.surfaceCopyIcon;
}, ";}:hover{svg{fill:", function (props) {
  return props.theme.codeBlockColors.surfaceCopyIconHover;
}, ";}}");

var TooltipWrapperComponent = function TooltipWrapperComponent(props) {
  return /*#__PURE__*/ReactDOM.createPortal(props.children, document.body);
};

var TooltipBodyComponent = function TooltipBodyComponent(props) {
  var theme = useTheme();
  return jsx("div", _extends({
    css: /*#__PURE__*/css("background-color:", theme.codeBlockColors.surfaceCopyTooltip, ";border-radius:", tokens.borderRadiusForTooltip, ";color:", theme.codeBlockColors.textCopyTooltip, ";font-size:", typography.fontSizes.extraSmall, ";padding:", dimensions.spacings.xs, " ", dimensions.spacings.s, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:TooltipBodyComponent;"))
  }, props));
};

var getLineStyles = function getLineStyles(theme, options) {
  var promptLineStyles;
  var highlightLineStyles;

  if (options.isCommandLine) {
    promptLineStyles = /*#__PURE__*/css("margin:0 0 0 ", dimensions.spacings.m, ";::before{content:attr(data-prompt);margin:0 0 0 -", dimensions.spacings.m, ";padding:0 ", dimensions.spacings.s, " 0 0;color:", options.shouldShowPrompt ? theme.codeBlockColors.surfacePrompt : 'transparent', ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:promptLineStyles;"));
  }

  if (options.shouldHighlightLine) {
    var width = options.isCommandLine ? "calc(100% - ".concat(dimensions.spacings.s, ")") : '100%';
    highlightLineStyles = /*#__PURE__*/css("background-color:", theme.codeBlockColors.surfaceLineHighlight, ";width:", width, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:highlightLineStyles;"));
  }

  return [promptLineStyles, highlightLineStyles];
};
/**
 * This components implements most of the logic from `gatsby-remark-prismjs`.
 * https://github.com/gatsbyjs/gatsby/blob/master/packages/gatsby-remark-prismjs
 *
 * We need to implement this logic on our own (at least for now) because of the
 * copy-to-clipboard functionality, as we need access to the raw content.
 * If we were to use the gatsby plugin, we would get the formatted content from props.
 *
 * ## Description
 * The CodeBlock component is used to provide syntax highlighting to the markdown
 * code block syntax ```.
 * It supports all the "common languages" as well as some extra features.
 *
 * ## Usage
 * The normal way to use it is by adding the appropriate language of your choice next
 * to the code block syntax:
 *
 * ```javascript
 * // This is a js comment
 * ```
 *
 * ## Additional features
 * The CodeBlock component also supports optional features to enhance the final output.
 * Those features are controlled by using the "infostring" syntax supported by MDX.
 * https://github.com/mdx-js/mdx/pull/257
 *
 * ```javascript foo=bar
 * // This is a js comment
 * ```
 *
 * Given the above syntax, the CodeBlock component will receive the following props:
 *
 * {
 *   children: {
 *    props: {
 *      children: '// This is a js comment',
 *      className: 'language-javascript',
 *      foo: 'bar',
 *      mdxType: 'code',
 *      metastring: 'foo=bar',
 *      originalType: 'code',
 *      parentName: 'pre',
 *    }
 *   }
 * }
 *
 * However, to support values with whitespaces between words (e.g. `title="This is a title"`)
 * we need to add a **restriction to always wrap the value in quotes**!
 *
 * ### Title
 * This feature allows to pass a title to the code block header.
 * To use this, you need to pass `title="<title>"`.
 *
 * ```javascript title="Sum function implementation"
 * const sum = (x, y) => {
 *   if (typeof x !== 'number' || typeof y !== 'number') {
 *     throw new Error('Both arguments need to be numbers.');
 *   }
 *   return x + y;
 * }
 * ```
 *
 * ### Highlighted lines
 * This feature allows to select lines to be visually highlighted in the final output.
 * To use this, you need to pass `highlightLines="<range>"`. The range can be a single line
 * number or a range of line numbers separated by `-`. Multiple highlighted lines can be
 * provided as comma-separated values.
 *
 * ```javascript highlightLines="1,5"
 * const sum = (x, y) => {
 *   if (typeof x !== 'number' || typeof y !== 'number') {
 *     throw new Error('Both arguments need to be numbers.');
 *   }
 *   return x + y;
 * }
 * ```
 *
 * ### Prompt lines
 * This feature allows to remove the prompt `$` from the specified lines.
 * To use this, you need to pass `noPromptLines="<range>"`. The range can be a single line
 * number or a range of line numbers separated by `-`. Multiple lines can be
 * provided as comma-separated values.
 * This feature only works for the `console` or `terminal` language syntax.
 *
 * ```console noPromptLines="1-2,5-6"
 * cd project
 * cp -R \
 *   dist \
 *   public/
 * rm -rf dist
 * yarn start
 * ```
 */


var languageAliases = {
  sh: 'bash',
  zsh: 'bash',
  console: 'bash',
  terminal: 'bash',
  curl: 'bash',
  js: 'javascript',
  yml: 'yaml'
};

var CodeBlock = function CodeBlock(props) {
  var _context;

  var languageCode = props.language || 'text';
  var language = languageAliases[languageCode] || languageCode;

  var isCommandLine = _includesInstanceProperty(_context = ['terminal', 'console']).call(_context, languageCode); // Copy to clipboard logic


  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isCopiedToClipboard = _React$useState2[0],
      setIsCopiedToClipboard = _React$useState2[1];

  var handleCopyToClipboardClick = function handleCopyToClipboardClick() {
    copyToClipboard(props.content);
    setIsCopiedToClipboard(true);

    _setTimeout(function () {
      setIsCopiedToClipboard(false);
    }, 1500);
  };

  var codeBlockTheme = {
    codeBlockColors: colors.light.codeBlocks[props.secondaryTheme ? 'secondary' : 'primary']
  };
  return jsx(ThemeProvider, {
    theme: codeBlockTheme
  }, jsx(Highlight, _extends({}, defaultProps, {
    code: props.content,
    language: language,
    theme: props.secondaryTheme ? commercetoolsLightTheme : commercetoolsTheme
  }), function (_ref) {
    var className = _ref.className,
        style = _ref.style,
        syntaxTokens = _ref.tokens,
        getLineProps = _ref.getLineProps,
        getTokenProps = _ref.getTokenProps;
    return jsx(HighlightedContainer, {
      theme: codeBlockTheme
    }, jsx(SpacingsInline, {
      scale: "xs",
      alignItems: "flex-start"
    }, jsx(Preformatted, {
      className: className,
      style: style,
      theme: codeBlockTheme
    }, _mapInstanceProperty(syntaxTokens).call(syntaxTokens, function (line, index) {
      var _context2, _context3;

      var isLastLine = syntaxTokens.length - 1 === index;

      if (isLastLine) {
        if (line.length === 1 && line[0].empty) {
          return null;
        }
      }

      var shouldShowPrompt = isCommandLine && props.noPromptLines ? !_includesInstanceProperty(_context2 = props.noPromptLines).call(_context2, index + 1) : false;
      var shouldHighlightLine = props.highlightLines && props.highlightLines.length > 0 ? _someInstanceProperty(_context3 = props.highlightLines).call(_context3, function (highlightine) {
        return highlightine === index + 1;
      }) : false;
      return jsx("div", _extends({
        key: index
      }, getLineProps(_objectSpread$2({
        line: line,
        key: index
      }, isCommandLine ? {
        'data-prompt': '$'
      } : {})), {
        css: getLineStyles(codeBlockTheme, {
          isCommandLine: isCommandLine,
          shouldShowPrompt: shouldShowPrompt,
          shouldHighlightLine: shouldHighlightLine
        })
      }), _mapInstanceProperty(line).call(line, function (token, key) {
        return jsx("span", _extends({
          key: key
        }, getTokenProps({
          token: token,
          key: key
        })));
      }));
    })), jsx(Tooltip, {
      placement: "left",
      title: isCopiedToClipboard ? 'Copied' : 'Copy to clipboard',
      components: {
        TooltipWrapperComponent: TooltipWrapperComponent,
        BodyComponent: TooltipBodyComponent
      }
    }, jsx(CopyArea, {
      onClick: handleCopyToClipboardClick,
      theme: codeBlockTheme
    }, jsx(ClipboardIcon, null)))));
  }));
};

CodeBlock.propTypes = process.env.NODE_ENV !== "production" ? {
  secondaryTheme: _pt.bool,
  language: _pt.string,
  highlightLines: _pt.arrayOf(_pt.number),
  noPromptLines: _pt.arrayOf(_pt.number),
  content: _pt.string.isRequired
} : {};

var Container$1 = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "ee36co95"
} : {
  target: "ee36co95",
  label: "Container"
})("background-color:", function (props) {
  return props.theme.codeBlockColors.surface;
}, ";border:1px solid ", function (props) {
  return props.theme.codeBlockColors.border;
}, ";border-radius:", tokens.borderRadiusForCodeBlock, ";word-break:break-word;");

var Header = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "ee36co94"
} : {
  target: "ee36co94",
  label: "Header"
})("background-color:", function (props) {
  return props.theme.codeBlockColors.surfaceHeader;
}, ";border-radius:", tokens.borderRadiusForCodeBlock, " ", tokens.borderRadiusForCodeBlock, " 0 0;border-bottom:1px solid ", function (props) {
  return props.theme.codeBlockColors.border;
}, ";padding:", dimensions.spacings.s, " ", dimensions.spacings.m, ";");

var HeaderInner = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "ee36co93"
} : {
  target: "ee36co93",
  label: "HeaderInner"
})("display:grid;grid-gap:", dimensions.spacings.m, ";grid-template-columns:auto 1fr;");

var HeaderText = _styled("span", process.env.NODE_ENV === "production" ? {
  target: "ee36co92"
} : {
  target: "ee36co92",
  label: "HeaderText"
})("color:", function (props) {
  return props.theme.codeBlockColors.textHeader;
}, ";");

var getCaretSvgUrl = function getCaretSvgUrl(color) {
  return "url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='24px' height='24px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Icons' stroke='none' stroke-width='1' fill-rule='evenodd'%3E%3Cg id='MC-icon-set' transform='translate(-168.000000, -936.000000)' fill='%23".concat(color, "'%3E%3Cg id='Directions' transform='translate(24.000000, 888.000000)'%3E%3Cg id='Caret-Down' transform='translate(144.000000, 48.000000)'%3E%3Cpath d='M20.6658731,7.4053255 C20.4433682,7.16948908 20.1796129,7.05166867 19.8748538,7.05166867 L4.12508466,7.05166867 C3.82020235,7.05166867 3.55663185,7.16948908 3.33394217,7.4053255 C3.11125249,7.64142273 3,7.92055342 3,8.24323919 C3,8.56585976 3.11125249,8.84499045 3.33394217,9.08089208 L11.2088575,17.4207121 C11.4317935,17.6565485 11.695364,17.7746297 12,17.7746297 C12.304636,17.7746297 12.5684528,17.6565485 12.7909578,17.4207121 L20.6658731,9.08082687 C20.8883165,8.84499045 21,8.56585976 21,8.24317399 C21,7.92055342 20.8883165,7.64142273 20.6658731,7.4053255 L20.6658731,7.4053255 Z' id='shape'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")");
};

var LanguagesDropDownWrapper = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "ee36co91"
} : {
  target: "ee36co91",
  label: "LanguagesDropDownWrapper"
})("background-image:", function (props) {
  return getCaretSvgUrl(props.theme.codeBlockColors.surfaceLanguageDropdown.replace('#', ''));
}, ";background-repeat:no-repeat,repeat;background-position:right 0 top 50%,0 0;background-size:", dimensions.widths.selectDropDownArrowWith, " auto,100%;");

var LanguagesDropDown = _styled("select", process.env.NODE_ENV === "production" ? {
  target: "ee36co90"
} : {
  target: "ee36co90",
  label: "LanguagesDropDown"
})("display:block;font-size:", typography.fontSizes.body, ";line-height:", typography.lineHeights.body, ";color:", function (props) {
  return props.theme.codeBlockColors.surfaceLanguageDropdown;
}, ";padding-right:", dimensions.spacings.m, ";box-sizing:border-box;cursor:pointer;border:none;appearance:none;background:transparent;option{color:black;}::-ms-expand{display:none;}:hover{color:", function (props) {
  return props.theme.codeBlockColors.surfaceLanguageDropdownHover;
}, ";}:focus{outline:none;}");

var languageDisplayNames = {
  sh: 'Terminal',
  zsh: 'Terminal',
  console: 'Terminal',
  bash: 'Terminal',
  curl: 'cURL',
  js: 'JavaScript',
  javascript: 'JavaScript',
  jsx: 'JavaScript React',
  java: 'Java',
  scala: 'Scala',
  php: 'PHP',
  cs: 'C#',
  ts: 'TypeScript',
  tsx: 'TypeScript React',
  python: 'Python',
  go: 'Go',
  swift: 'Swift',
  ruby: 'Ruby',
  objectivec: 'Objective-C'
};

function extractLanguages(children) {
  if (_Array$isArray(children)) {
    return _mapInstanceProperty(children).call(children, function (child) {
      return child.props.language;
    });
  }

  return [children.props.language];
}

function MultiCodeBlock(props) {
  var langs = extractLanguages(props.children);

  var _React$useState = React.useState(langs[0]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selected = _React$useState2[0],
      setSelected = _React$useState2[1];

  var handleOnLanguageChange = React.useCallback(function (event) {
    setSelected(event.target.value);
  }, []);
  var codeBlockTheme = {
    codeBlockColors: colors.light.codeBlocks[props.secondaryTheme ? 'secondary' : 'primary']
  };
  var selectedElement;

  if (_Array$isArray(props.children)) {
    var _context;

    selectedElement = _findInstanceProperty(_context = props.children).call(_context, function (child) {
      return child.props.language === selected;
    }) || undefined;
  } else {
    selectedElement = props.children;
  }

  return jsx(ThemeProvider, {
    theme: codeBlockTheme
  }, jsx(Container$1, {
    theme: codeBlockTheme
  }, props.title || langs.length > 1 ? jsx(Header, {
    theme: codeBlockTheme
  }, jsx(HeaderInner, null, jsx(HeaderText, {
    theme: codeBlockTheme
  }, props.title), jsx(SpacingsInline, {
    scale: "m",
    alignItems: "center",
    justifyContent: "flex-end"
  }, function () {
    if (langs.length > 1) {
      return jsx(LanguagesDropDownWrapper, {
        theme: codeBlockTheme
      }, jsx(LanguagesDropDown, {
        theme: codeBlockTheme,
        onChange: handleOnLanguageChange
      }, _mapInstanceProperty(langs).call(langs, function (lang) {
        return jsx("option", {
          key: lang,
          value: lang
        }, languageDisplayNames[lang] || lang);
      })));
    }

    return langs[0] === 'text' ? null : jsx(HeaderText, {
      theme: codeBlockTheme
    }, languageDisplayNames[langs[0]] || langs[0]);
  }()))) : null, selectedElement && /*#__PURE__*/React.cloneElement(selectedElement, {
    secondaryTheme: props.secondaryTheme
  })));
}

MultiCodeBlock.propTypes = process.env.NODE_ENV !== "production" ? {
  secondaryTheme: _pt.bool,
  title: _pt.string,
  children: _pt.oneOfType([_pt.element, _pt.arrayOf(_pt.element)]).isRequired
} : {};
/* eslint-disable react/display-name */
// Maps the props coming from MDX to the underlying <CodeBlock> component.

var CodeBlockMarkdownWrapper = function CodeBlockMarkdownWrapper(props) {
  var childElement = reactIs.isElement(props.children) ? props.children : null;
  var childProps = childElement === null || childElement === void 0 ? void 0 : childElement.props;
  var className = childProps ? childProps.className : '';
  var languageToken = className || 'language-text';

  var _languageToken$split = languageToken.split('language-'),
      _languageToken$split2 = _slicedToArray(_languageToken$split, 2),
      languageCode = _languageToken$split2[1];

  var parsedOptions = parseCodeBlockOptions(childProps);
  var content = childProps && childProps.children ? childProps.children : childProps;
  return jsx(MultiCodeBlock, parsedOptions, jsx(CodeBlock, _extends({}, parsedOptions, {
    content: content,
    language: languageCode
  })));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$2 = process.env.NODE_ENV === "production" ? {
  name: "v5igdj",
  styles: "line-height:1.3"
} : {
  name: "1uku7t5-headerStyles",
  styles: "line-height:1.3;label:headerStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
};

var headerStyles = function headerStyles() {
  return _ref$2;
};

var Paragraph = _styled("p", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a825"
} : {
  target: "e1yuh3a825",
  label: "Paragraph"
})(process.env.NODE_ENV === "production" ? {
  name: "ti75j2",
  styles: "margin:0"
} : {
  name: "ti75j2",
  styles: "margin:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});

var H1 = _styled("h1", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a824"
} : {
  target: "e1yuh3a824",
  label: "H1"
})(headerStyles, ";font-size:", typography.fontSizes.h1, ";font-weight:", typography.fontWeights.regular, ";line-height:1.15;color:", function (props) {
  return props.theme.websitePrimaryColor;
}, ";margin:0 0 ", dimensions.spacings.s, ";");

var H2 = _styled("h2", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a823"
} : {
  target: "e1yuh3a823",
  label: "H2"
})(headerStyles, ";font-size:", typography.fontSizes.h2, ";font-weight:", typography.fontWeights.bold, ";border-bottom:1px solid ", colors.light.borderPrimary, ";padding-bottom:", dimensions.spacings.s, ";");

var H3 = _styled("h3", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a822"
} : {
  target: "e1yuh3a822",
  label: "H3"
})(headerStyles, ";font-size:", typography.fontSizes.h3, ";font-weight:", typography.fontWeights.medium, ";");

var H4 = _styled("h4", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a821"
} : {
  target: "e1yuh3a821",
  label: "H4"
})(headerStyles, ";font-size:", typography.fontSizes.h4, ";font-weight:", typography.fontWeights.medium, ";");

var H5 = _styled("h5", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a820"
} : {
  target: "e1yuh3a820",
  label: "H5"
})(headerStyles, ";font-size:", typography.fontSizes.h5, ";font-weight:", typography.fontWeights.regular, ";");

var H6 = _styled("h6", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a819"
} : {
  target: "e1yuh3a819",
  label: "H6"
})(headerStyles, ";font-size:", typography.fontSizes.h6, ";font-weight:", typography.fontWeights.regular, ";line-height:1.4;");

var ThematicBreak = _styled("hr", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a818"
} : {
  target: "e1yuh3a818",
  label: "ThematicBreak"
})(process.env.NODE_ENV === "production" ? {
  name: "eivff4",
  styles: "display:none"
} : {
  name: "eivff4",
  styles: "display:none",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});

var Ul = _styled("ul", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a817"
} : {
  target: "e1yuh3a817",
  label: "Ul"
})("padding-left:", dimensions.spacings.xl, ";list-style-type:disc;>*+*{margin-top:", dimensions.spacings.s, ";}");

var Ol = _styled("ol", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a816"
} : {
  target: "e1yuh3a816",
  label: "Ol"
})("padding-left:", dimensions.spacings.xl, ";>*+*{margin-top:", dimensions.spacings.s, ";}");

var Dl = _styled("dl", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a815"
} : {
  target: "e1yuh3a815",
  label: "Dl"
})(">*+dt{margin:", dimensions.spacings.s, " 0 0;}>*+dd{margin:", dimensions.spacings.xs, " 0 0;}");

var Dt = _styled("dt", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a814"
} : {
  target: "e1yuh3a814",
  label: "Dt"
})("color:", colors.light.textSecondary, ";");
/*
The "container" styles have to be applied to containers that render markdown inside a surrounding
visual box like a blockquote, notification box, card, or Subtitle.
Heading margins are not set here because headings can and should not be used inside such containers.
*/


var containerStyles = function containerStyles() {
  return /*#__PURE__*/css(">*+*{margin-top:", dimensions.spacings.m, ";}>*+", Ul, ",>*+", Ol, ",>*+", Dl, "{margin-top:", dimensions.spacings.s, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:containerStyles;"));
};

var Dd = _styled("dd", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a813"
} : {
  target: "e1yuh3a813",
  label: "Dd"
})(containerStyles, " padding:0 0 0 ", dimensions.spacings.l, ";>*+*{margin:", dimensions.spacings.s, " 0;}");

var Li = _styled("li", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a812"
} : {
  target: "e1yuh3a812",
  label: "Li"
})(containerStyles, ";line-height:1.46;>ul,>ol{margin:", dimensions.spacings.s, " 0 ", dimensions.spacings.m, ";}>ul{list-style-type:circle;}");

var Blockquote = _styled("blockquote", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a811"
} : {
  target: "e1yuh3a811",
  label: "Blockquote"
})(containerStyles, ";background-color:", colors.light.surfaceQuote, ";border-left:1px solid ", colors.light.borderHighlight, ";border-radius:0 ", tokens.borderRadiusForBlockquote, " ", tokens.borderRadiusForBlockquote, " 0;color:", colors.light.textFaded, ";font-size:", typography.fontSizes.small, ";padding:", dimensions.spacings.xs, " ", dimensions.spacings.s, ";");

var Table$1 = _styled("table", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a810"
} : {
  target: "e1yuh3a810",
  label: "Table"
})("width:100%;border:1px solid ", colors.light.borderPrimary, ";border-top:2px solid ", colors.light.borderPrimary, ";border-collapse:collapse;font-size:", typography.fontSizes.body, ";margin:0;tbody{border-top:2px solid ", colors.light.borderPrimary, ";}thead tr{background:", colors.light.surfacePrimary, "!important;}@media screen and (", dimensions.viewports.mobile, "){display:block;tbody{display:block;}thead{display:block;}thead tr{position:absolute;top:-9999px;left:-9999px;}", function (props) {
  var _context, _context2;

  var tableHeaders = _findInstanceProperty(_context = React.Children.toArray(props.children)).call(_context, function (elem) {
    return reactIs.isElement(elem) && (elem.type === 'thead' || elem.props.mdxType === 'thead');
  });

  if (!tableHeaders) return null;
  var rowHeaders = reactIs.isElement(tableHeaders) && tableHeaders.props.children;
  var rowHeadersChildren = _Array$isArray(rowHeaders) ? rowHeaders : rowHeaders.props.children;
  return _reduceInstanceProperty(_context2 = React.Children.toArray(rowHeadersChildren)).call(_context2, function (styles, elem, index) {
    var _context3, _context4;

    return _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = "\n        ".concat(styles, "\n        td:nth-of-type(")).call(_context4, index + 1, ")::before { content: \"")).call(_context3, reactIs.isElement(elem) && elem.props.children, "\"; }\n      ");
  }, '');
}, ";}");

var TableRow = _styled("tr", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a89"
} : {
  target: "e1yuh3a89",
  label: "TableRow"
})("&:nth-of-type(odd){background:", colors.light.surfaceSecondary1, ";}&:nth-of-type(even){background:", colors.light.surfacePrimary, ";}>*+*{border-left:1px solid ", colors.light.borderPrimary, ";}@media screen and (", dimensions.viewports.mobile, "){display:block;border:1px solid ", colors.light.borderPrimary, ";}");

var TableCell = _styled("td", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a88"
} : {
  target: "e1yuh3a88",
  label: "TableCell"
})(containerStyles, ";border-bottom:1px solid ", colors.light.borderPrimary, ";font-size:", typography.fontSizes.small, ";padding:", dimensions.spacings.s, ";white-space:pre-wrap;vertical-align:top;text-align:", function (props) {
  return props.align || 'left';
}, ";@media screen and (", dimensions.viewports.mobile, "){display:block;border:none;border-bottom:1px solid ", colors.light.borderPrimary, ";::before{display:flex;font-weight:", typography.fontWeights.bold, ";}}");

var TableHeader = _styled("th", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a87"
} : {
  target: "e1yuh3a87",
  label: "TableHeader"
})(containerStyles, ";font-size:", typography.fontSizes.small, ";padding:", dimensions.spacings.s, ";text-align:left;@media screen and (", dimensions.viewports.mobile, "){display:block;}");

var InlineCode = _styled("code", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a86"
} : {
  target: "e1yuh3a86",
  label: "InlineCode"
})("background-color:", colors.light.surfaceInlineCode, ";border:1px solid ", colors.light.borderSecondary, ";border-radius:", dimensions.spacings.xs, ";color:", colors.light.textCode, ";font-family:", typography.fontFamilies.code, ";font-size:", typography.fontSizes.small, ";padding:0 ", dimensions.spacings.xs, ";");

var Em = _styled("em", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a85"
} : {
  target: "e1yuh3a85",
  label: "Em"
})();

var Strong = _styled("strong", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a84"
} : {
  target: "e1yuh3a84",
  label: "Strong"
})();

var Delete = _styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a83"
} : {
  target: "e1yuh3a83",
  label: "Delete"
})(process.env.NODE_ENV === "production" ? {
  name: "1rcj98u",
  styles: "text-decoration:line-through"
} : {
  name: "1rcj98u",
  styles: "text-decoration:line-through",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});

var Hr = /*#__PURE__*/_styled(ThematicBreak, process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a82"
} : {
  target: "e1yuh3a82",
  label: "Hr"
})();

var TypographyPage = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a81"
} : {
  target: "e1yuh3a81",
  label: "TypographyPage"
})("font-family:", typography.fontFamilies.primary, ";font-size:", typography.fontSizes.body, ";font-weight:", typography.fontWeights.regular, ";line-height:1.5;section>*+*{margin-top:", dimensions.spacings.m, ";}section:first-of-type>*:first-child{margin-top:0!important;}section>", H2, "+*,section>", H3, "+*,section>", H4, "+*,section>", H5, "+*,section>", H6, "+*{margin-top:", dimensions.spacings.s, ";}.section-h4,.section-h5,.section-h6,.section-h7{padding:0 0 0 ", dimensions.spacings.l, ";}section>", H2, "{margin:", dimensions.spacings.huge, " 0 ", dimensions.spacings.m, ";}section>", H3, "{margin:", dimensions.spacings.big, " 0 0;}section>", H4, "{margin:", dimensions.spacings.xl, " 0 0;}section>", H5, "{margin:", dimensions.spacings.xl, " 0 0;}section>", H6, "{margin:", dimensions.spacings.m, " 0 ", dimensions.spacings.s, ";}section>", Blockquote, "{margin:", dimensions.spacings.l, " ", dimensions.spacings.xxl, ";}section>", Ul, ",section>", Ol, ",section>", Dl, "{margin-top:", dimensions.spacings.s, ";}");

var TypographyContainer = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yuh3a80"
} : {
  target: "e1yuh3a80",
  label: "TypographyContainer"
})(containerStyles, ";");
/* eslint-disable react/display-name */
// eslint-disable-next-line @typescript-eslint/no-explicit-any


var withAnchorLink = function withAnchorLink(Component) {
  return function (props) {
    return jsx(Component, _extends({}, props, {
      css: /*#__PURE__*/css("display:flex;align-items:baseline;:hover{[data-link-type='anchor-link']{svg{*{fill:", colors.light.linkNavigation, ";}}}}>*+*{margin:0 0 0 ", dimensions.spacings.s, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:withAnchorLink;"))
    }), jsx("span", null, props.children), jsx("a", {
      href: "#".concat(props.id),
      "data-link-type": "anchor-link"
    }, jsx(SvgRibbon, null)));
  };
};

var markdown = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TypographyPage: TypographyPage,
  TypographyContainer: TypographyContainer,
  Paragraph: Paragraph,
  H1: H1,
  H2: H2,
  H3: H3,
  H4: H4,
  H5: H5,
  H6: H6,
  ThematicBreak: ThematicBreak,
  Blockquote: Blockquote,
  Ul: Ul,
  Ol: Ol,
  Li: Li,
  Dl: Dl,
  Dt: Dt,
  Dd: Dd,
  Table: Table$1,
  TableRow: TableRow,
  TableCell: TableCell,
  TableHeader: TableHeader,
  InlineCode: InlineCode,
  CodeBlock: CodeBlockMarkdownWrapper,
  Em: Em,
  Strong: Strong,
  Delete: Delete,
  Hr: Hr,
  withAnchorLink: withAnchorLink
});

var getIconByType = function getIconByType(type) {
  switch (type) {
    case 'warning':
      return WarningIcon;

    case 'error':
      return ErrorIcon;

    default:
      return InformationIcon;
  }
};

var getIconColorByType = function getIconColorByType(type) {
  switch (type) {
    case 'warning':
      return 'warning';

    case 'error':
      return 'error';

    default:
      return 'info';
  }
};

var Container = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "ezkukxj0"
} : {
  target: "ezkukxj0",
  label: "Container"
})("background-color:", function (props) {
  switch (props.type) {
    case 'warning':
      return colors.light.surfaceWarning;

    case 'error':
      return colors.light.surfaceError;

    default:
      return colors.light.surfaceInfo;
  }
}, ";border:1px solid ", function (props) {
  switch (props.type) {
    case 'warning':
      return colors.light.textWarning;

    case 'error':
      return colors.light.textError;

    default:
      return colors.light.textInfo;
  }
}, ";border-radius:", tokens.borderRadiusForContentNotification, ";padding:", dimensions.spacings.m, ";");

var ContentNotification = function ContentNotification(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'info' : _ref$type,
      children = _ref.children;
  var Icon = getIconByType(type);
  var iconColor = getIconColorByType(type);
  return jsx(Container, {
    type: type
  }, jsx(SpacingsInline, {
    scale: "s",
    alignItems: "flex-start"
  }, jsx("div", null, jsx(Icon, {
    color: iconColor
  })), jsx(TypographyContainer, null, children)));
};

ContentNotification.propTypes = process.env.NODE_ENV !== "production" ? {
  type: _pt.oneOf(['error', 'warning', 'info']),
  children: _pt.node
} : {};

var Info = function Info(props) {
  return jsx(ContentNotification, _extends({}, props, {
    type: "info"
  }));
};

Info.propTypes = process.env.NODE_ENV !== "production" ? {
  type: _pt.oneOf(['error', 'warning', 'info']),
  children: _pt.node
} : {};

var Error$1 = function Error(props) {
  return jsx(ContentNotification, _extends({}, props, {
    type: "error"
  }));
};

Error$1.propTypes = process.env.NODE_ENV !== "production" ? {
  type: _pt.oneOf(['error', 'warning', 'info']),
  children: _pt.node
} : {};

var Warning = function Warning(props) {
  return jsx(ContentNotification, _extends({}, props, {
    type: "warning"
  }));
};

Warning.propTypes = process.env.NODE_ENV !== "production" ? {
  type: _pt.oneOf(['error', 'warning', 'info']),
  children: _pt.node
} : {};
var ContentNotifications = {
  Info: Info,
  Error: Error$1,
  Warning: Warning
};

var isoDateRegex = /^\d{4}-\d{2}-\d{2}$/; // if the date does not contain timezone, JS Date() is fine

var parseIsoDate = function parseIsoDate(dateString) {
  // as an extra safety net enforce UTC midnight
  var UTCDateString = dateString + 'T00:00:00.000Z';
  var date = new Date(UTCDateString);
  return !isNaN(date.valueOf()) && isoDateRegex.test(dateString) ? date : false;
}; // Canada has adopted ISO-8601 so it's used as a replacement for the missing
// explicit ISO format support in Javascript Intl

var IsoDateFormat = new Intl.DateTimeFormat('en-CA', {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric'
}); // For docs content we have adopted the British style "4 December 1970" format.

var DocsDateFormat = new Intl.DateTimeFormat('en-GB', {
  year: 'numeric',
  month: 'long',
  day: 'numeric'
}); // if you have to parse such a "docs" date, you likely have a different root problem,
// formatted dates should never have to be parsed.
// Worst case use Luxon. Do not use moment.js any more. It's unmaintained and too large.

var Link$1 = _styled("a", process.env.NODE_ENV === "production" ? {
  target: "ecrcgas0"
} : {
  target: "ecrcgas0",
  label: "Link"
})("&,>code{color:", colors.light.link, ";:active,:focus,:hover{color:", colors.light.linkHover, ";}}");

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Table = _styled("table", process.env.NODE_ENV === "production" ? {
  target: "e1rq8nl71"
} : {
  target: "e1rq8nl71",
  label: "Table"
})("width:100%;border-radius:", tokens.borderRadiusForRssFeedTable, ";box-shadow:", tokens.shadowForRssFeedTable, ";tbody{tr{td{padding:", dimensions.spacings.m, ";:first-of-type{color:", colors.light.linkHover, ";}}:not(:first-of-type){border-top:1px solid ", colors.light.borderPrimary, ";}}}");

var DateWrapper = _styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1rq8nl70"
} : {
  target: "e1rq8nl70",
  label: "DateWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1bmnxg7",
  styles: "white-space:nowrap"
} : {
  name: "1bmnxg7",
  styles: "white-space:nowrap",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});

var _ref$1 = process.env.NODE_ENV === "production" ? {
  name: "g65o95",
  styles: "text-decoration:none"
} : {
  name: "1odge61-RssFeedTable",
  styles: "text-decoration:none;label:RssFeedTable;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "g65o95",
  styles: "text-decoration:none"
} : {
  name: "1odge61-RssFeedTable",
  styles: "text-decoration:none;label:RssFeedTable;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};

var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "1bmnxg7",
  styles: "white-space:nowrap"
} : {
  name: "o3n55d-RssFeedTable",
  styles: "white-space:nowrap;label:RssFeedTable;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};

var RssFeedTable = function RssFeedTable(props) {
  var _context;

  if (!props.data) {
    var message = 'Must pass data to RssFeedTable component.';

    if (process.env.NODE_ENV !== 'production') {
      return jsx(ContentNotifications.Error, null, message);
    }

    throw new Error(message);
  }

  return jsx("div", null, jsx(Table, {
    "data-table-name": "rss-feed"
  }, jsx("tbody", null, _mapInstanceProperty(_context = props.data).call(_context, function (item, index) {
    var _context2;

    return jsx("tr", {
      key: _concatInstanceProperty(_context2 = "".concat(item.title)).call(_context2, index)
    }, jsx("td", {
      css: _ref3
    }, jsx(DateWrapper, null, jsx(Link$1, {
      href: item.link,
      css: _ref2
    }, DocsDateFormat.format(new Date(item.pubDate))))), props.hasMultipleSources ? jsx("td", {
      css: /*#__PURE__*/css("white-space:nowrap;padding-left:", dimensions.spacings.l, "!important;" + (process.env.NODE_ENV === "production" ? "" : ";label:RssFeedTable;"))
    }, jsx(Link$1, {
      href: item.releaseNoteUrl,
      css: _ref$1
    }, item.feedName)) : null, jsx("td", null, item.title));
  }))));
};

RssFeedTable.propTypes = process.env.NODE_ENV !== "production" ? {
  data: _pt.array.isRequired,
  hasMultipleSources: _pt.bool.isRequired
} : {};

function ownKeys$1(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var _context11, _context12; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context11 = ownKeys$1(Object(source), !0)).call(_context11, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context12 = ownKeys$1(Object(source))).call(_context12, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var firstDataForQuery = function firstDataForQuery(node, query) {
  var _firstChild$textConte;

  var firstChild = node.querySelector(query);
  return firstChild === null || firstChild === void 0 ? void 0 : (_firstChild$textConte = firstChild.textContent) === null || _firstChild$textConte === void 0 ? void 0 : _trimInstanceProperty(_firstChild$textConte).call(_firstChild$textConte);
}; // Inspired by https://css-tricks.com/how-to-fetch-and-parse-rss-feeds-in-javascript/


var parseRssFeed = function parseRssFeed(rssString) {
  var _context;

  var documentFragment = new window.DOMParser().parseFromString(rssString, 'text/xml');
  var feedTitle = firstDataForQuery(documentFragment, 'title') || '';

  var items = _mapInstanceProperty(_context = _Array$from(documentFragment.querySelectorAll('item'))).call(_context, function (el) {
    var title = firstDataForQuery(el, 'title') || '';
    var description = firstDataForQuery(el, 'description') || '';
    var link = firstDataForQuery(el, 'link') || '';
    var pubDate = firstDataForQuery(el, 'pubDate') || '';
    return {
      title: title,
      description: description,
      link: link,
      pubDate: pubDate
    };
  });

  return {
    feedTitle: feedTitle,
    items: items
  };
};

var fetchRssFeed = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var response, rawBody;
    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(url);

          case 2:
            response = _context2.sent;
            _context2.next = 5;
            return response.text();

          case 5:
            rawBody = _context2.sent;
            return _context2.abrupt("return", parseRssFeed(rawBody));

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee);
  }));

  return function fetchRssFeed(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetcher = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _len,
        args,
        _key,
        promises,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            for (_len = _args3.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _args3[_key];
            }

            promises = _mapInstanceProperty(args).call(args, /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url) {
                var _context3;

                var releaseNoteUrl, feedData, feedName, refactoredData;
                return _regeneratorRuntime.wrap(function _callee2$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        releaseNoteUrl = url.replace(/\/feed.xml$/, '');
                        _context4.next = 3;
                        return fetchRssFeed(url);

                      case 3:
                        feedData = _context4.sent;
                        feedName = feedData.feedTitle.replace(/^commercetools (.*) Release Notes$/, '$1');
                        refactoredData = _mapInstanceProperty(_context3 = feedData.items).call(_context3, function (item) {
                          return _objectSpread$1(_objectSpread$1({}, item), {}, {
                            feedName: feedName,
                            releaseNoteUrl: releaseNoteUrl
                          });
                        });
                        return _context4.abrupt("return", refactoredData);

                      case 7:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x2) {
                return _ref3.apply(this, arguments);
              };
            }());
            return _context5.abrupt("return", _Promise.all(promises));

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee3);
  }));

  return function fetcher() {
    return _ref2.apply(this, arguments);
  };
}();

var transformData = function transformData(data) {
  var _context6, _context8, _context9;

  // First, we need to get the oldest release note from each feed,
  // which is always the last entry of the list.
  var lastEntryOfList = _reduceInstanceProperty(_context6 = _reduceInstanceProperty(data).call(data, function (list, feed) {
    var _context7;

    return _concatInstanceProperty(_context7 = []).call(_context7, _toConsumableArray(list), [feed[feed.length - 1]]);
  }, []) // After that, we need to compare the oldest release dates from each feed
  // to get the newest of them. This will be our last entry in the list.
  ).call(_context6, function (currentOldestEntry, entry, index) {
    if (!entry || index === 0) {
      return entry;
    }

    return new Date(entry.pubDate) > new Date(currentOldestEntry.pubDate) ? entry : currentOldestEntry;
  }, {}); // After finding out the last entry in the list, we reduce the list
  // to all entries that have a newer date than our last entry.


  var tableData = _sortInstanceProperty(_context8 = _reduceInstanceProperty(_context9 = _flatInstanceProperty(data).call(data)).call(_context9, function (list, entry) {
    var _context10;

    return new Date(entry.pubDate) >= new Date(lastEntryOfList.pubDate) ? _concatInstanceProperty(_context10 = []).call(_context10, _toConsumableArray(list), [entry]) : _toConsumableArray(list);
  }, []) // Now we sort the release notes by their release date.
  ).call(_context8, function (dateOne, dateTwo) {
    return new Date(dateTwo.pubDate).getTime() - new Date(dateOne.pubDate).getTime();
  });

  return tableData;
};

var RssFeeds = function RssFeeds(props) {
  if (!props.dataSources) {
    var message = "Missing prop \"dataSources\" for the \"<RssFeeds>\" component.";

    if (process.env.NODE_ENV !== 'production') {
      return jsx(ContentNotifications.Error, null, message);
    }

    throw new Error(message);
  } // eslint-disable-next-line react-hooks/rules-of-hooks


  var _useSWR = useSWR(props.dataSources, fetcher),
      data = _useSWR.data,
      error = _useSWR.error;

  if (error) {
    console.log(error);

    var _message = jsx(ContentNotifications.Error, null, "Error Loading Data from ", props.dataSources);

    return _message;
  }

  if (data) {
    return jsx(RssFeedTable, {
      hasMultipleSources: props.dataSources.length > 1,
      data: transformData(data)
    });
  }

  return jsx(LoadingSpinner, {
    scale: "s"
  }, 'Loading feeds');
};

RssFeeds.propTypes = process.env.NODE_ENV !== "production" ? {
  dataSources: _pt.arrayOf(_pt.string).isRequired
} : {};

var Globals = function Globals() {
  return jsx(Global, {
    styles: /*#__PURE__*/css("html,body{padding:0;margin:0;height:100vh;color:", colors.light.textPrimary, ";font-family:", typography.fontFamilies.primary, ";font-size:", typography.rootFontSize, ";font-weight:", typography.fontWeights.regular, ";}iframe{border:0;outline:0;padding:0;margin:0;}[data-reach-skip-link]:focus{z-index:100;}.gatsby-resp-image-wrapper{background-color:", colors.light.surfaceSecondary1, ";border-radius:", tokens.borderRadiusForImageFrame, ";margin:", dimensions.spacings.m, " 0 ", dimensions.spacings.xxl, ";padding:", dimensions.spacings.s, ";}.gatsby-resp-image-figure{background-color:", colors.light.surfaceSecondary1, ";border-radius:", tokens.borderRadiusForImageFrame, ";margin:0;padding:", dimensions.spacings.s, ";}.gatsby-resp-image-link{text-decoration:none;}.gatsby-resp-image-image{background-color:", colors.light.surfacePrimary, ";box-shadow:none!important;width:calc(100% - ", dimensions.spacings.s, " * 2)!important;height:auto!important;margin:", dimensions.spacings.s, "!important;}.gatsby-resp-image-figure .gatsby-resp-image-wrapper{background-color:unset;border-radius:unset;margin:unset;padding:unset;}.gatsby-resp-image-figure .gatsby-resp-image-image{width:100%!important;height:unset!important;margin:unset!important;}.gatsby-resp-image-figcaption{color:", colors.light.textSecondary, ";font-size:", typography.fontSizes.small, ";margin:", dimensions.spacings.xs, " 0 0;}code,kbd,samp,pre{font-family:", typography.fontFamilies.code, ",'Menlo','Monaco','Consolas','Liberation Mono','Courier New',monospace;font-size:", typography.fontSizes.small, ";}b,strong{font-weight:", typography.fontWeights.bold, ";}small{font-size:", typography.fontSizes.small, ";}sub,sup{font-size:", typography.fontSizes.extraSmall, ";line-height:0;position:relative;}ul,ol{list-style-position:outside;padding-inline-start:0;-webkit-padding-start:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:Globals;"))
  });
};

var LinkContainer = _styled("span", process.env.NODE_ENV === "production" ? {
  target: "eoxdbxa2"
} : {
  target: "eoxdbxa2",
  label: "LinkContainer"
})("padding:0 ", dimensions.spacings.m, ";height:100%;display:flex;flex-direction:column;justify-content:center;"); // This is a normal HTML link as we need to force a redirect to the root domain


var Link = _styled("a", process.env.NODE_ENV === "production" ? {
  target: "eoxdbxa1"
} : {
  target: "eoxdbxa1",
  label: "Link"
})("color:", colors.light.textPrimary, ";text-decoration:none;white-space:nowrap;cursor:pointer;display:block;width:100%;");

var Title$1 = _styled("span", process.env.NODE_ENV === "production" ? {
  target: "eoxdbxa0"
} : {
  target: "eoxdbxa0",
  label: "Title"
})("display:none;font-size:", typography.fontSizes.body, ";@media screen and (", dimensions.viewports.laptop, "){display:block;}@media screen and (", dimensions.viewports.desktop, "){font-size:", typography.fontSizes.h4, ";}");

var LogoButton = function LogoButton() {
  return jsx(Link, {
    href: "/"
  }, jsx(LinkContainer, null, jsx(SpacingsInline, {
    scale: "m",
    alignItems: "center"
  }, jsx(SvgLogo, {
    height: 32
  }), jsx(Title$1, null, 'Documentation'))));
};

LogoButton.displayName = 'LogoButton';

var MediaQuery = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e65a6d60"
} : {
  target: "e65a6d60",
  label: "MediaQuery"
})(function (props) {
  switch (props.forViewport) {
    case 'mobile':
      return /*#__PURE__*/css("display:", props.hideIfMatch ? 'block' : 'none', ";@media screen and (", dimensions.viewports.mobile, "){display:", props.hideIfMatch ? 'none' : 'block', ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:MediaQuery;"));

    case 'tablet':
      return /*#__PURE__*/css("display:", props.hideIfMatch ? 'block' : 'none', ";@media screen and (", dimensions.viewports.tablet, "){display:", props.hideIfMatch ? 'none' : 'block', ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:MediaQuery;"));

    case 'largeTablet':
      return /*#__PURE__*/css("display:", props.hideIfMatch ? 'block' : 'none', ";@media screen and (", dimensions.viewports.largeTablet, "){display:", props.hideIfMatch ? 'none' : 'block', ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:MediaQuery;"));

    case 'laptop':
      return /*#__PURE__*/css("display:", props.hideIfMatch ? 'block' : 'none', ";@media screen and (", dimensions.viewports.laptop, "){display:", props.hideIfMatch ? 'none' : 'block', ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:MediaQuery;"));

    default:
      return /*#__PURE__*/css(process.env.NODE_ENV === "production" ? "" : ";label:MediaQuery;");
  }
}, ";");

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref = process.env.NODE_ENV === "production" ? {
  name: "iskwe5",
  styles: "html,body,#___gatsby,#gatsby-focus-wrapper{height:100%;width:100%;}html,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,embed,figure,figcaption,footer,header,hgroup,menu,nav,output,ruby,section,summary,time,mark,audio,video{margin:0;padding:0;border:0;font-size:100%;vertical-align:baseline;}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block;}blockquote,q{quotes:none;}blockquote::before,blockquote::after,q::before,q::after{content:'';}table{border-collapse:collapse;border-spacing:0;}body{margin:0;padding:0;border:0;font-style:normal;font-variant:normal;font-stretch:normal;text-align:left;vertical-align:baseline;text-rendering:optimizelegibility;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:rgba(black 0);}[tabindex='-1']:focus:not(:focus-visible){outline:0!important;}img{max-width:100%;}svg{overflow:hidden;vertical-align:middle;}caption{text-align:center;caption-side:bottom;}hr{height:0;overflow:visible;}abbr[title]{border-bottom:none;text-decoration:underline dotted;}sub{bottom:-0.25em;}sup{top:-0.5em;}label{display:inline-block;}button{border-radius:0;}button,input{overflow:visible;}button:focus{outline:1px dotted;}button,select{text-transform:none;}select{word-wrap:normal;}button,[type='button'],[type='reset'],[type='submit']{-webkit-appearance:button;}input[type='radio'],input[type='checkbox']{box-sizing:border-box;}textarea{overflow:auto;resize:vertical;}fieldset{min-width:0;}legend{line-height:inherit;color:inherit;white-space:normal;}[type='number']::-webkit-inner-spin-button,[type='number']::-webkit-outer-spin-button{height:auto;}[type='search'],[type='search']::-webkit-search-decoration{-webkit-appearance:none;}::-webkit-file-upload-button{-webkit-appearance:button;}output{display:inline-block;}summary{display:list-item;cursor:pointer;}template{display:none;}[hidden]{display:none!important;}"
} : {
  name: "q0d9u1-Reset",
  styles: "html,body,#___gatsby,#gatsby-focus-wrapper{height:100%;width:100%;}html,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,embed,figure,figcaption,footer,header,hgroup,menu,nav,output,ruby,section,summary,time,mark,audio,video{margin:0;padding:0;border:0;font-size:100%;vertical-align:baseline;}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block;}blockquote,q{quotes:none;}blockquote::before,blockquote::after,q::before,q::after{content:'';}table{border-collapse:collapse;border-spacing:0;}body{margin:0;padding:0;border:0;font-style:normal;font-variant:normal;font-stretch:normal;text-align:left;vertical-align:baseline;text-rendering:optimizelegibility;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:rgba(black 0);}[tabindex='-1']:focus:not(:focus-visible){outline:0!important;}img{max-width:100%;}svg{overflow:hidden;vertical-align:middle;}caption{text-align:center;caption-side:bottom;}hr{height:0;overflow:visible;}abbr[title]{border-bottom:none;text-decoration:underline dotted;}sub{bottom:-0.25em;}sup{top:-0.5em;}label{display:inline-block;}button{border-radius:0;}button,input{overflow:visible;}button:focus{outline:1px dotted;}button,select{text-transform:none;}select{word-wrap:normal;}button,[type='button'],[type='reset'],[type='submit']{-webkit-appearance:button;}input[type='radio'],input[type='checkbox']{box-sizing:border-box;}textarea{overflow:auto;resize:vertical;}fieldset{min-width:0;}legend{line-height:inherit;color:inherit;white-space:normal;}[type='number']::-webkit-inner-spin-button,[type='number']::-webkit-outer-spin-button{height:auto;}[type='search'],[type='search']::-webkit-search-decoration{-webkit-appearance:none;}::-webkit-file-upload-button{-webkit-appearance:button;}output{display:inline-block;}summary{display:list-item;cursor:pointer;}template{display:none;}[hidden]{display:none!important;};label:Reset;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};

var Reset = function Reset() {
  return jsx(React.Fragment, null, jsx(Global, {
    styles: _ref
  }));
};

var Subtitle = /*#__PURE__*/_styled(TypographyContainer, process.env.NODE_ENV === "production" ? {
  target: "egp8w9y0"
} : {
  target: "egp8w9y0",
  label: "Subtitle"
})("font-size:", typography.fontSizes.h3, ";");

var TextSmall = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "eak6k4o0"
} : {
  target: "eak6k4o0",
  label: "TextSmall"
})("font-size:", typography.fontSizes.small, ";color:", colors.light.textSecondary, ";");

var MermaidLazy = /*#__PURE__*/React.lazy(function () {
  return import('./mermaid-client-side-825787a8.esm.js');
});

var Mermaid = function Mermaid(props) {
  var isClientSide = typeof window !== 'undefined';
  return jsx(React.Fragment, null, isClientSide && jsx(React.Suspense, {
    fallback: jsx(LoadingSpinner, {
      scale: "l",
      maxDelayDuration: 500
    })
  }, jsx(MermaidLazy, {
    graph: props.graph
  })));
};

Mermaid.propTypes = process.env.NODE_ENV !== "production" ? {
  graph: _pt.string.isRequired
} : {};

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/**
 * the docs ui kit provides the basic elements to compose card UIs but does not provide
 * the finished card, which would imply how Links are handled and would imply certain context
 *
 * A full composition of a card could look like:
 * <CardContainer {...props}>
 *  <Link>
 *    <StackContainer>
 *        <ImageContainer>{props.image}</ImageContainer>
 *          <StackContainer>
 *            <IconContainer>{props.icon}</IconContainer>}
 *            <StackContainer scale="s">
 *              <Title smallTitle={props.smallTitle}>{props.title}</Title>
 *                <BodyContainer>
 *                  <BodyContent clickable={props.clickable}>
 *                    {props.children}
 *                  </BodyContent>
 *                </BodyContainer>
 *                <ReadMoreContainer>
 *                  <ReadMore>
 *                    <Link href={props.href} noUnderline>
 *                        {props.textLink}
 *                    </Link>
 *                  </ReadMore>
 *                </ReadMoreContainer>
 *            </StackContainer>
 *        </StackContainer>
 *      </StackContainer>
 *    </Link>
 *  </CardContainer>
 */

var CardsContainer = _styled("ul", process.env.NODE_ENV === "production" ? {
  target: "ehwpbfx9"
} : {
  target: "ehwpbfx9",
  label: "CardsContainer"
})("list-style:none;display:grid;gap:", dimensions.spacings.m, ";grid-auto-columns:1fr;grid-template-columns:", function (props) {
  var columnMinWidth;

  if (props.narrow) {
    columnMinWidth = dimensions.widths.cardNarrowMinWidth;
  } else {
    columnMinWidth = props.fitContentColumn ? dimensions.widths.cardRegularMinWidthInContentColumn : dimensions.widths.cardRegularMinWidth;
  }

  return "repeat( auto-fill, minmax(".concat(columnMinWidth, ", 1fr)) ");
}, ";");
var flatStyle = /*#__PURE__*/css("border:1px solid ", colors.light.borderSecondary, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:flatStyle;"));
var clickableStyle = /*#__PURE__*/css("cursor:pointer;box-shadow:", tokens.shadowForClickableCard, ";:hover{box-shadow:", tokens.shadowForClickableCardOnHover, ";}transition:box-shadow 0.1s ease-in-out;" + (process.env.NODE_ENV === "production" ? "" : ";label:clickableStyle;"));
var CardContainer = _styled("li", process.env.NODE_ENV === "production" ? {
  target: "ehwpbfx8"
} : {
  target: "ehwpbfx8",
  label: "CardContainer"
})(function (props) {
  return props.clickable ? clickableStyle : flatStyle;
}, ";background-color:", colors.light.surfacePrimary, ";padding:", dimensions.spacings.m, ";border-radius:", tokens.borderRadiusForCard, ";");
var ImageContainer = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "ehwpbfx7"
} : {
  target: "ehwpbfx7",
  label: "ImageContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "k3xix6",
  styles: "svg,img{width:100%;height:auto;}"
} : {
  name: "k3xix6",
  styles: "svg,img{width:100%;height:auto;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var IconContainer = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "ehwpbfx6"
} : {
  target: "ehwpbfx6",
  label: "IconContainer"
})("width:", dimensions.spacings.big, ";min-width:", dimensions.spacings.big, ";height:", dimensions.spacings.big, ";svg{width:100%;height:100%;}");
var InlineContainer = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "ehwpbfx5"
} : {
  target: "ehwpbfx5",
  label: "InlineContainer"
})("display:flex;height:100%;>*+*{margin-left:", dimensions.spacings.m, ";}");
var normalTitle = /*#__PURE__*/css("font-size:", typography.fontSizes.h3, ";line-height:", typography.lineHeights.cardNormalTitle, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:normalTitle;"));
var smallTitle = /*#__PURE__*/css("font-size:", typography.fontSizes.h4, ";line-height:", typography.lineHeights.cardSmallTitle, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:smallTitle;"));
var Title = _styled("h6", process.env.NODE_ENV === "production" ? {
  target: "ehwpbfx4"
} : {
  target: "ehwpbfx4",
  label: "Title"
})(function (props) {
  return props.smallTitle ? smallTitle : normalTitle;
}, ";color:", colors.light.textPrimary, ";font-weight:", typography.fontWeights.medium, ";letter-spacing:0;");
var BodyContainer = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "ehwpbfx3"
} : {
  target: "ehwpbfx3",
  label: "BodyContainer"
})("color:", colors.light.textPrimary, ";");
var ReadMoreContainer = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "ehwpbfx2"
} : {
  target: "ehwpbfx2",
  label: "ReadMoreContainer"
})();
var ReadMore = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "ehwpbfx1"
} : {
  target: "ehwpbfx1",
  label: "ReadMore"
})("border-top:1px solid ", colors.light.borderSecondary, ";padding-top:", dimensions.spacings.m, ";margin-top:", dimensions.spacings.m, ";");

var getStackContainerMarginStyle = function getStackContainerMarginStyle(props) {
  switch (props.scale) {
    case 's':
      return dimensions.spacings.s;

    default:
      return dimensions.spacings.m;
  }
};

var StackContainer = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "ehwpbfx0"
} : {
  target: "ehwpbfx0",
  label: "StackContainer"
})("flex-grow:1;display:flex;height:100%;flex-direction:column;>*+*{margin-top:", getStackContainerMarginStyle, ";}>", ReadMoreContainer, "{margin-top:auto;}");

var cardElements = /*#__PURE__*/Object.freeze({
  __proto__: null,
  CardsContainer: CardsContainer,
  CardContainer: CardContainer,
  ImageContainer: ImageContainer,
  IconContainer: IconContainer,
  InlineContainer: InlineContainer,
  Title: Title,
  BodyContainer: BodyContainer,
  ReadMoreContainer: ReadMoreContainer,
  ReadMore: ReadMore,
  StackContainer: StackContainer
});

var iconSizes = {
  small: 12,
  medium: 16,
  big: 24
};

var getSizeStyle = function getSizeStyle(size) {
  var _context, _context2;

  switch (size) {
    case 'scale':
      return "\n        &:not(:root) {\n          width: 100%;\n          height: auto;\n        }\n      ";

    case 'small':
    case 'medium':
    case 'big':
      return _concatInstanceProperty(_context = "\n        width: ".concat(iconSizes[size], "px;\n        height: ")).call(_context, iconSizes[size], "px;\n      ");

    default:
      return _concatInstanceProperty(_context2 = "\n        width: ".concat(iconSizes.big, "px;\n        height: ")).call(_context2, iconSizes.big, "px;\n      ");
  }
};

var getColor = function getColor(color) {
  if (!color) return 'inherit';
  var iconColor = colors.light[color];

  if (!iconColor) {
    !color ? process.env.NODE_ENV !== "production" ? invariant(false, "ui-kit/Icon: the specified color '".concat(color, "' is not supported.")) : invariant(false) : void 0;
    return 'inherit';
  }

  return iconColor;
};

function createStyledIcon(Component) {
  var StyledComponent = /*#__PURE__*/_styled(Component, process.env.NODE_ENV === "production" ? {
    target: "evnivnw0"
  } : {
    target: "evnivnw0",
    label: "StyledComponent"
  })(function (props) {
    return /*#__PURE__*/css("*:not([fill='none']){fill:", getColor(props.color), ";}", getSizeStyle(props.size), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledComponent;"));
  });

  return StyledComponent;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var SafeHTMLElement = canUseDOM ? window.HTMLElement : {};

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context, _context2; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(source), !0)).call(_context, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
// with types. Type modeling the ast transform chaining would be very abstract, require a lot
// of understanding of the rehype / remark / unified infrastructure with little gain.

var Div = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1bd8pfk1"
} : {
  target: "e1bd8pfk1",
  label: "Div"
})();

var Heading = _styled("p", process.env.NODE_ENV === "production" ? {
  target: "e1bd8pfk0"
} : {
  target: "e1bd8pfk0",
  label: "Heading"
})("font-weight:", typography.fontWeights.bold, ";"); // No images should be rendered in fragments that are embedded into other layouts


var MarkdownFragmentImage = function MarkdownFragmentImage() {
  return null;
};

var removeFrontmatterPlugin = function removeFrontmatterPlugin() {
  return function (tree) {
    return filter(tree, function (node) {
      return node.type !== 'yaml';
    });
  };
};

var noOpPlugin = function noOpPlugin() {
  return function (ast) {
    return ast;
  };
};
/**
 * Takes a markdown string and returns a react component rendering it
 * in a way that is safe to embed into arbitrary places of a larger document.
 * Therefore it does not render structural elements and elements that would visually
 * break if embedded into a table cell, list item or preview fragment in an article list.
 * - headings rendered as strong emphasis, but not structural headings
 * - tables rendered as bullet lists (one list per row)
 * - code blocks rendered as inline code
 * - none of the custom MDX components available -> for example subtitle
 *
 * Elements can be customized with the customElements object, its structure should be like so:
 * {
 *  a: custom-link-component,
 *  p: custom-paragraph-component,
 * }
 *
 * @param {string}  markdownString
 * @param {Object.<string, React.ComponentType>} customElements - custom HTML element to component mapping
 * @param {function} customPlugin - additional remark plugins to be applied before processing
 * @returns {React.ReactNode} -
 */


var markdownFragmentToReact = function markdownFragmentToReact(markdownString, customElements, customPlugin) {
  var safeCustomPlugin = typeof customPlugin === 'function' ? customPlugin : noOpPlugin;
  return unified().use(remarkParse).use(remarkFrontmatter).use(removeFrontmatterPlugin).use(safeCustomPlugin).use(remarkRehype).use(rehypeReact, {
    createElement: React.createElement,
    Fragment: React.Fragment,
    components: _objectSpread({
      p: Paragraph,
      a: Link$1,
      h1: Heading,
      h2: Heading,
      h3: Heading,
      h4: Heading,
      h5: Heading,
      h6: Heading,
      thematicBreak: ThematicBreak,
      blockquote: Blockquote,
      ul: Ul,
      ol: Ol,
      li: Li,
      dl: Dl,
      dt: Dt,
      dd: Dd,
      table: Div,
      thead: Div,
      tbody: Div,
      tr: Ul,
      td: Li,
      th: Li,
      code: InlineCode,
      pre: InlineCode,
      em: Em,
      strong: Strong,
      delete: Delete,
      hr: Hr,
      img: MarkdownFragmentImage
    }, customElements)
  }).processSync(markdownString).result;
};

var narrowNonBreakingSpace = "\u202F";

var useISO310NumberFormatter = function useISO310NumberFormatter() {
  var intl = useIntl();
  return useCallback(function (value) {
    var _context;

    if (typeof value !== 'number') return value;
    return _mapInstanceProperty(_context = intl.formatNumberToParts(value, {
      maximumFractionDigits: 20
    })).call(_context, function (_ref) {
      var type = _ref.type,
          value = _ref.value;
      return type === 'group' ? narrowNonBreakingSpace : value;
    }).join('');
  }, [intl]);
};

export { ContentNotifications as C, DocsDateFormat as D, Globals as G, IsoDateFormat as I, Link$1 as L, MediaQuery as M, RssFeeds as R, Subtitle as S, TextSmall as T, tokens as a, designSystem as b, colors as c, dimensions as d, cardElements as e, LogoButton as f, MultiCodeBlock as g, Reset as h, index as i, Mermaid as j, CodeBlock as k, createStyledIcon as l, markdown as m, SafeHTMLElement as n, markdownFragmentToReact as o, parseIsoDate as p, typography as t, useISO310NumberFormatter as u };
